// Mock Data for Asset Management System
import type { Asset, Transaction, KPI, AuditEntry } from '@/types/asset';

export const mockAssets: Asset[] = [
  // Computer Equipment (15 assets)
  {
    id: '1',
    assetId: 'COMP-001',
    name: 'Dell Latitude 7420 Laptop',
    description: 'High-performance business laptop',
    category: 'Computer Equipment',
    subCategory: 'Laptops',
    location: 'London HQ',
    department: 'Finance',
    status: 'active',
    acquisitionCost: 1250.00,
    netBookValue: 62.50,
    accumulatedDepreciation: 1187.50,
    currency: 'GBP',
    acquisitionDate: '2022-01-15',
    depreciationMethod: 'Straight Line',
    usefulLife: 4,
    residualValue: 100,
    serialNumber: 'DL7420-001',
    manufacturer: 'Dell',
    model: 'Latitude 7420',
    barcode: 'BC-COMP-001',
    assignedTo: 'Sarah Johnson',
    assignedDate: '2022-01-20',
    insurancePolicyNumber: 'INS-2024-001',
    insuranceProvider: 'Tech Insurance Ltd',
    insuranceExpiryDate: '2025-11-15',
    insuranceValue: 1250.00,
    warrantyExpiryDate: '2025-01-15',
    warrantyProvider: 'Dell',
    supplierId: 'SUP-001',
    supplierName: 'Tech Solutions UK',
    purchaseOrderNumber: 'PO-2022-001',
    notes: 'Standard issue laptop',
    imageUrl: 'https://images.unsplash.com/photo-1588872657578-7efd1f1555ed?w=400&h=300&fit=crop',
    createdBy: 'admin',
    createdDate: '2022-01-15T10:00:00Z',
    tags: ['IT', 'Finance'],
  },
  {
    id: '2',
    assetId: 'COMP-002',
    name: 'HP EliteBook 840',
    description: 'Business laptop',
    category: 'Computer Equipment',
    subCategory: 'Laptops',
    location: 'Manchester Office',
    department: 'Sales',
    status: 'active',
    acquisitionCost: 1100.00,
    netBookValue: 88.00,
    accumulatedDepreciation: 1012.00,
    currency: 'GBP',
    acquisitionDate: '2022-03-10',
    depreciationMethod: 'Straight Line',
    usefulLife: 4,
    residualValue: 100,
    serialNumber: 'HP840-002',
    manufacturer: 'HP',
    model: 'EliteBook 840',
    barcode: 'BC-COMP-002',
    supplierId: 'SUP-001',
    supplierName: 'Tech Solutions UK',
    purchaseOrderNumber: 'PO-2022-015',
    imageUrl: 'https://images.unsplash.com/photo-1496181133206-80ce9b88a853?w=400&h=300&fit=crop',
    createdBy: 'admin',
    createdDate: '2022-03-10T10:00:00Z',
    tags: ['IT', 'Sales'],
  },
  {
    id: '3',
    assetId: 'COMP-003',
    name: 'Lenovo ThinkPad X1',
    description: 'Premium business laptop',
    category: 'Computer Equipment',
    subCategory: 'Laptops',
    location: 'London HQ',
    department: 'IT',
    status: 'active',
    acquisitionCost: 1500.00,
    netBookValue: 1125.00,
    accumulatedDepreciation: 375.00,
    currency: 'GBP',
    acquisitionDate: '2023-06-01',
    depreciationMethod: 'Straight Line',
    usefulLife: 4,
    residualValue: 150,
    serialNumber: 'LTX1-003',
    manufacturer: 'Lenovo',
    model: 'ThinkPad X1',
    barcode: 'BC-COMP-003',
    supplierId: 'SUP-002',
    supplierName: 'Computer World',
    purchaseOrderNumber: 'PO-2023-045',
    imageUrl: 'https://images.unsplash.com/photo-1588872657578-7efd1f1555ed?w=400&h=300&fit=crop',
    createdBy: 'admin',
    createdDate: '2023-06-01T10:00:00Z',
    tags: ['IT', 'Premium'],
  },
  {
    id: '4',
    assetId: 'COMP-004',
    name: 'Apple iMac 27"',
    description: 'Desktop computer for design',
    category: 'Computer Equipment',
    subCategory: 'Desktops',
    location: 'London HQ',
    department: 'Marketing',
    status: 'active',
    acquisitionCost: 2200.00,
    netBookValue: 1320.00,
    accumulatedDepreciation: 880.00,
    currency: 'GBP',
    acquisitionDate: '2022-09-15',
    depreciationMethod: 'Straight Line',
    usefulLife: 5,
    residualValue: 200,
    serialNumber: 'IMAC27-004',
    manufacturer: 'Apple',
    model: 'iMac 27"',
    barcode: 'BC-COMP-004',
    supplierId: 'SUP-003',
    supplierName: 'Apple Store',
    purchaseOrderNumber: 'PO-2022-089',
    imageUrl: 'https://images.unsplash.com/photo-1517694712202-14dd9538aa97?w=400&h=300&fit=crop',
    insuranceExpiryDate: '2024-12-28',
    createdBy: 'admin',
    createdDate: '2022-09-15T10:00:00Z',
    tags: ['IT', 'Design'],
  },
  {
    id: '5',
    assetId: 'COMP-005',
    name: 'Dell OptiPlex 7090',
    description: 'Desktop computer',
    category: 'Computer Equipment',
    subCategory: 'Desktops',
    location: 'Birmingham Warehouse',
    department: 'Operations',
    status: 'active',
    acquisitionCost: 950.00,
    netBookValue: 570.00,
    accumulatedDepreciation: 380.00,
    currency: 'GBP',
    acquisitionDate: '2022-11-20',
    depreciationMethod: 'Straight Line',
    usefulLife: 5,
    residualValue: 100,
    serialNumber: 'DO7090-005',
    manufacturer: 'Dell',
    model: 'OptiPlex 7090',
    barcode: 'BC-COMP-005',
    supplierId: 'SUP-001',
    supplierName: 'Tech Solutions UK',
    purchaseOrderNumber: 'PO-2022-112',
    imageUrl: 'https://images.unsplash.com/photo-1587831990711-23ca6441447b?w=400&h=300&fit=crop',
    createdBy: 'admin',
    createdDate: '2022-11-20T10:00:00Z',
    tags: ['IT', 'Operations'],
  },
  {
    id: '6',
    assetId: 'COMP-006',
    name: 'HP ProDesk 600',
    description: 'Desktop computer',
    category: 'Computer Equipment',
    subCategory: 'Desktops',
    location: 'Manchester Office',
    department: 'HR',
    status: 'active',
    acquisitionCost: 850.00,
    netBookValue: 68.00,
    accumulatedDepreciation: 782.00,
    currency: 'GBP',
    acquisitionDate: '2022-04-10',
    depreciationMethod: 'Straight Line',
    usefulLife: 4,
    residualValue: 100,
    serialNumber: 'HP600-006',
    manufacturer: 'HP',
    model: 'ProDesk 600',
    barcode: 'BC-COMP-006',
    supplierId: 'SUP-001',
    supplierName: 'Tech Solutions UK',
    purchaseOrderNumber: 'PO-2022-034',
    imageUrl: 'https://images.unsplash.com/photo-1593642632823-8f785ba67e45?w=400&h=300&fit=crop',
    createdBy: 'admin',
    createdDate: '2022-04-10T10:00:00Z',
    tags: ['IT', 'HR'],
  },
  {
    id: '7',
    assetId: 'COMP-007',
    name: 'MacBook Pro 16"',
    description: 'High-performance laptop',
    category: 'Computer Equipment',
    subCategory: 'Laptops',
    location: 'London HQ',
    department: 'Development',
    status: 'active',
    acquisitionCost: 3200.00,
    netBookValue: 2400.00,
    accumulatedDepreciation: 800.00,
    currency: 'GBP',
    acquisitionDate: '2023-09-01',
    depreciationMethod: 'Straight Line',
    usefulLife: 4,
    residualValue: 400,
    serialNumber: 'MBP16-007',
    manufacturer: 'Apple',
    model: 'MacBook Pro 16"',
    barcode: 'BC-COMP-007',
    supplierId: 'SUP-003',
    supplierName: 'Apple Store',
    purchaseOrderNumber: 'PO-2023-078',
    imageUrl: 'https://images.unsplash.com/photo-1517336714731-489689fd1ca8?w=400&h=300&fit=crop',
    insuranceExpiryDate: '2025-11-20',
    createdBy: 'admin',
    createdDate: '2023-09-01T10:00:00Z',
    tags: ['IT', 'Development'],
  },
  {
    id: '8',
    assetId: 'COMP-008',
    name: 'Dell XPS 15',
    description: 'Premium laptop',
    category: 'Computer Equipment',
    subCategory: 'Laptops',
    location: 'Edinburgh Branch',
    department: 'Management',
    status: 'active',
    acquisitionCost: 1800.00,
    netBookValue: 1350.00,
    accumulatedDepreciation: 450.00,
    currency: 'GBP',
    acquisitionDate: '2023-07-15',
    depreciationMethod: 'Straight Line',
    usefulLife: 4,
    residualValue: 200,
    serialNumber: 'DXPS15-008',
    manufacturer: 'Dell',
    model: 'XPS 15',
    barcode: 'BC-COMP-008',
    supplierId: 'SUP-001',
    supplierName: 'Tech Solutions UK',
    purchaseOrderNumber: 'PO-2023-067',
    imageUrl: 'https://images.unsplash.com/photo-1593642632559-0c6d3fc62b89?w=400&h=300&fit=crop',
    createdBy: 'admin',
    createdDate: '2023-07-15T10:00:00Z',
    tags: ['IT', 'Management'],
  },
  {
    id: '9',
    assetId: 'COMP-009',
    name: 'HP ZBook Studio',
    description: 'Workstation laptop',
    category: 'Computer Equipment',
    subCategory: 'Laptops',
    location: 'London HQ',
    department: 'Design',
    status: 'active',
    acquisitionCost: 2500.00,
    netBookValue: 1875.00,
    accumulatedDepreciation: 625.00,
    currency: 'GBP',
    acquisitionDate: '2023-08-01',
    depreciationMethod: 'Straight Line',
    usefulLife: 4,
    residualValue: 300,
    serialNumber: 'HPZB-009',
    manufacturer: 'HP',
    model: 'ZBook Studio',
    barcode: 'BC-COMP-009',
    supplierId: 'SUP-001',
    supplierName: 'Tech Solutions UK',
    purchaseOrderNumber: 'PO-2023-071',
    imageUrl: 'https://images.unsplash.com/photo-1496181133206-80ce9b88a853?w=400&h=300&fit=crop',
    createdBy: 'admin',
    createdDate: '2023-08-01T10:00:00Z',
    tags: ['IT', 'Design'],
  },
  {
    id: '10',
    assetId: 'COMP-010',
    name: 'Lenovo ThinkCentre M90',
    description: 'Desktop computer',
    category: 'Computer Equipment',
    subCategory: 'Desktops',
    location: 'Manchester Office',
    department: 'Finance',
    status: 'active',
    acquisitionCost: 900.00,
    netBookValue: 540.00,
    accumulatedDepreciation: 360.00,
    currency: 'GBP',
    acquisitionDate: '2022-12-01',
    depreciationMethod: 'Straight Line',
    usefulLife: 5,
    residualValue: 100,
    serialNumber: 'LTM90-010',
    manufacturer: 'Lenovo',
    model: 'ThinkCentre M90',
    barcode: 'BC-COMP-010',
    supplierId: 'SUP-002',
    supplierName: 'Computer World',
    purchaseOrderNumber: 'PO-2022-125',
    imageUrl: 'https://images.unsplash.com/photo-1587831990711-23ca6441447b?w=400&h=300&fit=crop',
    createdBy: 'admin',
    createdDate: '2022-12-01T10:00:00Z',
    tags: ['IT', 'Finance'],
  },
  {
    id: '11',
    assetId: 'COMP-011',
    name: 'Microsoft Surface Pro 9',
    description: '2-in-1 tablet laptop',
    category: 'Computer Equipment',
    subCategory: 'Tablets',
    location: 'London HQ',
    department: 'Sales',
    status: 'active',
    acquisitionCost: 1400.00,
    netBookValue: 1050.00,
    accumulatedDepreciation: 350.00,
    currency: 'GBP',
    acquisitionDate: '2023-10-01',
    depreciationMethod: 'Straight Line',
    usefulLife: 4,
    residualValue: 150,
    serialNumber: 'MSP9-011',
    manufacturer: 'Microsoft',
    model: 'Surface Pro 9',
    barcode: 'BC-COMP-011',
    supplierId: 'SUP-004',
    supplierName: 'Microsoft Store',
    purchaseOrderNumber: 'PO-2023-092',
    imageUrl: 'https://images.unsplash.com/photo-1585790050230-5dd28404f1b4?w=400&h=300&fit=crop',
    createdBy: 'admin',
    createdDate: '2023-10-01T10:00:00Z',
    tags: ['IT', 'Sales'],
  },
  {
    id: '12',
    assetId: 'COMP-012',
    name: 'Dell Precision 5560',
    description: 'Mobile workstation',
    category: 'Computer Equipment',
    subCategory: 'Laptops',
    location: 'Birmingham Warehouse',
    department: 'Engineering',
    status: 'active',
    acquisitionCost: 2800.00,
    netBookValue: 2100.00,
    accumulatedDepreciation: 700.00,
    currency: 'GBP',
    acquisitionDate: '2023-11-01',
    depreciationMethod: 'Straight Line',
    usefulLife: 4,
    residualValue: 350,
    serialNumber: 'DP5560-012',
    manufacturer: 'Dell',
    model: 'Precision 5560',
    barcode: 'BC-COMP-012',
    supplierId: 'SUP-001',
    supplierName: 'Tech Solutions UK',
    purchaseOrderNumber: 'PO-2023-098',
    imageUrl: 'https://images.unsplash.com/photo-1593642632559-0c6d3fc62b89?w=400&h=300&fit=crop',
    createdBy: 'admin',
    createdDate: '2023-11-01T10:00:00Z',
    tags: ['IT', 'Engineering'],
  },
  {
    id: '13',
    assetId: 'COMP-013',
    name: 'HP EliteDesk 800',
    description: 'Desktop computer',
    category: 'Computer Equipment',
    subCategory: 'Desktops',
    location: 'Edinburgh Branch',
    department: 'Customer Service',
    status: 'active',
    acquisitionCost: 950.00,
    netBookValue: 712.50,
    accumulatedDepreciation: 237.50,
    currency: 'GBP',
    acquisitionDate: '2023-12-01',
    depreciationMethod: 'Straight Line',
    usefulLife: 4,
    residualValue: 100,
    serialNumber: 'HPED800-013',
    manufacturer: 'HP',
    model: 'EliteDesk 800',
    barcode: 'BC-COMP-013',
    supplierId: 'SUP-001',
    supplierName: 'Tech Solutions UK',
    purchaseOrderNumber: 'PO-2023-105',
    imageUrl: 'https://images.unsplash.com/photo-1593642632823-8f785ba67e45?w=400&h=300&fit=crop',
    createdBy: 'admin',
    createdDate: '2023-12-01T10:00:00Z',
    tags: ['IT', 'Customer Service'],
  },
  {
    id: '14',
    assetId: 'COMP-014',
    name: 'Asus ROG Zephyrus',
    description: 'High-performance laptop',
    category: 'Computer Equipment',
    subCategory: 'Laptops',
    location: 'London HQ',
    department: 'Development',
    status: 'active',
    acquisitionCost: 2200.00,
    netBookValue: 1650.00,
    accumulatedDepreciation: 550.00,
    currency: 'GBP',
    acquisitionDate: '2024-01-15',
    depreciationMethod: 'Straight Line',
    usefulLife: 4,
    residualValue: 250,
    serialNumber: 'ASROG-014',
    manufacturer: 'Asus',
    model: 'ROG Zephyrus',
    barcode: 'BC-COMP-014',
    supplierId: 'SUP-005',
    supplierName: 'Gaming Tech Ltd',
    purchaseOrderNumber: 'PO-2024-003',
    imageUrl: 'https://images.unsplash.com/photo-1603302576837-37561b2e2302?w=400&h=300&fit=crop',
    createdBy: 'admin',
    createdDate: '2024-01-15T10:00:00Z',
    tags: ['IT', 'Development'],
  },
  {
    id: '15',
    assetId: 'COMP-015',
    name: 'Acer Aspire Desktop',
    description: 'Budget desktop computer',
    category: 'Computer Equipment',
    subCategory: 'Desktops',
    location: 'Manchester Office',
    department: 'Administration',
    status: 'active',
    acquisitionCost: 650.00,
    netBookValue: 45.50,
    accumulatedDepreciation: 604.50,
    currency: 'GBP',
    acquisitionDate: '2023-03-01',
    depreciationMethod: 'Straight Line',
    usefulLife: 5,
    residualValue: 50,
    serialNumber: 'ACASP-015',
    manufacturer: 'Acer',
    model: 'Aspire Desktop',
    barcode: 'BC-COMP-015',
    supplierId: 'SUP-002',
    supplierName: 'Computer World',
    purchaseOrderNumber: 'PO-2023-025',
    imageUrl: 'https://images.unsplash.com/photo-1587831990711-23ca6441447b?w=400&h=300&fit=crop',
    createdBy: 'admin',
    createdDate: '2023-03-01T10:00:00Z',
    tags: ['IT', 'Administration'],
  },

  // Furniture & Fixtures (10 assets)
  {
    id: '16',
    assetId: 'FURN-001',
    name: 'Executive Desk - Oak',
    description: 'Large executive desk',
    category: 'Furniture & Fixtures',
    subCategory: 'Desks',
    location: 'London HQ',
    department: 'Management',
    status: 'active',
    acquisitionCost: 1200.00,
    netBookValue: 960.00,
    accumulatedDepreciation: 240.00,
    currency: 'GBP',
    acquisitionDate: '2022-01-10',
    depreciationMethod: 'Straight Line',
    usefulLife: 10,
    residualValue: 100,
    serialNumber: 'DESK-OAK-001',
    manufacturer: 'Office Furniture Co',
    model: 'Executive Oak',
    barcode: 'BC-FURN-001',
    supplierId: 'SUP-010',
    supplierName: 'Office Furniture Co',
    purchaseOrderNumber: 'PO-2022-005',
    imageUrl: 'https://images.unsplash.com/photo-1518455027359-f3f8164ba6bd?w=400&h=300&fit=crop',
    createdBy: 'admin',
    createdDate: '2022-01-10T10:00:00Z',
    tags: ['Furniture', 'Management'],
  },
  {
    id: '17',
    assetId: 'FURN-002',
    name: 'Herman Miller Aeron Chair',
    description: 'Ergonomic office chair',
    category: 'Furniture & Fixtures',
    subCategory: 'Seating',
    location: 'London HQ',
    department: 'IT',
    status: 'active',
    acquisitionCost: 950.00,
    netBookValue: 760.00,
    accumulatedDepreciation: 190.00,
    currency: 'GBP',
    acquisitionDate: '2022-02-15',
    depreciationMethod: 'Straight Line',
    usefulLife: 10,
    residualValue: 100,
    serialNumber: 'HM-AERON-002',
    manufacturer: 'Herman Miller',
    model: 'Aeron',
    barcode: 'BC-FURN-002',
    supplierId: 'SUP-011',
    supplierName: 'Ergonomic Solutions',
    purchaseOrderNumber: 'PO-2022-012',
    imageUrl: 'https://images.unsplash.com/photo-1580480055273-228ff5388ef8?w=400&h=300&fit=crop',
    createdBy: 'admin',
    createdDate: '2022-02-15T10:00:00Z',
    tags: ['Furniture', 'Ergonomic'],
  },
  {
    id: '18',
    assetId: 'FURN-003',
    name: 'Conference Table - 12 Seater',
    description: 'Large conference table',
    category: 'Furniture & Fixtures',
    subCategory: 'Tables',
    location: 'Manchester Office',
    department: 'General',
    status: 'active',
    acquisitionCost: 2500.00,
    netBookValue: 2000.00,
    accumulatedDepreciation: 500.00,
    currency: 'GBP',
    acquisitionDate: '2022-03-01',
    depreciationMethod: 'Straight Line',
    usefulLife: 10,
    residualValue: 200,
    serialNumber: 'CONF-12-003',
    manufacturer: 'Office Furniture Co',
    model: 'Conference Pro',
    barcode: 'BC-FURN-003',
    supplierId: 'SUP-010',
    supplierName: 'Office Furniture Co',
    purchaseOrderNumber: 'PO-2022-018',
    imageUrl: 'https://images.unsplash.com/photo-1556761175-4b46a572b786?w=400&h=300&fit=crop',
    createdBy: 'admin',
    createdDate: '2022-03-01T10:00:00Z',
    tags: ['Furniture', 'Conference'],
  },
  {
    id: '19',
    assetId: 'FURN-004',
    name: 'Filing Cabinet - 4 Drawer',
    description: 'Metal filing cabinet',
    category: 'Furniture & Fixtures',
    subCategory: 'Storage',
    location: 'Birmingham Warehouse',
    department: 'Administration',
    status: 'active',
    acquisitionCost: 350.00,
    netBookValue: 28.00,
    accumulatedDepreciation: 322.00,
    currency: 'GBP',
    acquisitionDate: '2022-04-10',
    depreciationMethod: 'Straight Line',
    usefulLife: 10,
    residualValue: 30,
    serialNumber: 'FC-4D-004',
    manufacturer: 'Steel Storage Ltd',
    model: 'Pro File 4',
    barcode: 'BC-FURN-004',
    supplierId: 'SUP-012',
    supplierName: 'Storage Solutions',
    purchaseOrderNumber: 'PO-2022-028',
    imageUrl: 'https://images.unsplash.com/photo-1600494603989-9650cf6ddd3d?w=400&h=300&fit=crop',
    createdBy: 'admin',
    createdDate: '2022-04-10T10:00:00Z',
    tags: ['Furniture', 'Storage'],
  },
  {
    id: '20',
    assetId: 'FURN-005',
    name: 'Reception Desk',
    description: 'Modern reception desk',
    category: 'Furniture & Fixtures',
    subCategory: 'Desks',
    location: 'London HQ',
    department: 'Reception',
    status: 'active',
    acquisitionCost: 1800.00,
    netBookValue: 1440.00,
    accumulatedDepreciation: 360.00,
    currency: 'GBP',
    acquisitionDate: '2022-05-01',
    depreciationMethod: 'Straight Line',
    usefulLife: 10,
    residualValue: 150,
    serialNumber: 'RECEP-005',
    manufacturer: 'Modern Office',
    model: 'Reception Pro',
    barcode: 'BC-FURN-005',
    supplierId: 'SUP-010',
    supplierName: 'Office Furniture Co',
    purchaseOrderNumber: 'PO-2022-035',
    imageUrl: 'https://images.unsplash.com/photo-1497366216548-37526070297c?w=400&h=300&fit=crop',
    createdBy: 'admin',
    createdDate: '2022-05-01T10:00:00Z',
    tags: ['Furniture', 'Reception'],
  },
  {
    id: '21',
    assetId: 'FURN-006',
    name: 'Bookshelf Unit - 6ft',
    description: 'Wooden bookshelf',
    category: 'Furniture & Fixtures',
    subCategory: 'Storage',
    location: 'Edinburgh Branch',
    department: 'General',
    status: 'active',
    acquisitionCost: 450.00,
    netBookValue: 360.00,
    accumulatedDepreciation: 90.00,
    currency: 'GBP',
    acquisitionDate: '2022-06-15',
    depreciationMethod: 'Straight Line',
    usefulLife: 10,
    residualValue: 40,
    serialNumber: 'BOOK-6FT-006',
    manufacturer: 'Wood Works',
    model: 'Classic Shelf',
    barcode: 'BC-FURN-006',
    supplierId: 'SUP-013',
    supplierName: 'Furniture Warehouse',
    purchaseOrderNumber: 'PO-2022-045',
    imageUrl: 'https://images.unsplash.com/photo-1594620302200-9a762244a156?w=400&h=300&fit=crop',
    createdBy: 'admin',
    createdDate: '2022-06-15T10:00:00Z',
    tags: ['Furniture', 'Storage'],
  },
  {
    id: '22',
    assetId: 'FURN-007',
    name: 'Standing Desk - Electric',
    description: 'Height-adjustable desk',
    category: 'Furniture & Fixtures',
    subCategory: 'Desks',
    location: 'London HQ',
    department: 'Development',
    status: 'active',
    acquisitionCost: 800.00,
    netBookValue: 640.00,
    accumulatedDepreciation: 160.00,
    currency: 'GBP',
    acquisitionDate: '2023-01-10',
    depreciationMethod: 'Straight Line',
    usefulLife: 10,
    residualValue: 80,
    serialNumber: 'STAND-ELEC-007',
    manufacturer: 'ErgoDesk',
    model: 'Pro Stand',
    barcode: 'BC-FURN-007',
    supplierId: 'SUP-011',
    supplierName: 'Ergonomic Solutions',
    purchaseOrderNumber: 'PO-2023-005',
    imageUrl: 'https://images.unsplash.com/photo-1595515106969-1ce29566ff1c?w=400&h=300&fit=crop',
    createdBy: 'admin',
    createdDate: '2023-01-10T10:00:00Z',
    tags: ['Furniture', 'Ergonomic'],
  },
  {
    id: '23',
    assetId: 'FURN-008',
    name: 'Office Chair - Mesh Back',
    description: 'Breathable office chair',
    category: 'Furniture & Fixtures',
    subCategory: 'Seating',
    location: 'Manchester Office',
    department: 'Sales',
    status: 'active',
    acquisitionCost: 280.00,
    netBookValue: 224.00,
    accumulatedDepreciation: 56.00,
    currency: 'GBP',
    acquisitionDate: '2023-02-01',
    depreciationMethod: 'Straight Line',
    usefulLife: 10,
    residualValue: 30,
    serialNumber: 'CHAIR-MESH-008',
    manufacturer: 'Office Comfort',
    model: 'Mesh Pro',
    barcode: 'BC-FURN-008',
    supplierId: 'SUP-010',
    supplierName: 'Office Furniture Co',
    purchaseOrderNumber: 'PO-2023-012',
    imageUrl: 'https://images.unsplash.com/photo-1580480055273-228ff5388ef8?w=400&h=300&fit=crop',
    createdBy: 'admin',
    createdDate: '2023-02-01T10:00:00Z',
    tags: ['Furniture', 'Seating'],
  },
  {
    id: '24',
    assetId: 'FURN-009',
    name: 'Meeting Room Table - 6 Seater',
    description: 'Medium meeting table',
    category: 'Furniture & Fixtures',
    subCategory: 'Tables',
    location: 'Birmingham Warehouse',
    department: 'General',
    status: 'active',
    acquisitionCost: 650.00,
    netBookValue: 520.00,
    accumulatedDepreciation: 130.00,
    currency: 'GBP',
    acquisitionDate: '2023-03-15',
    depreciationMethod: 'Straight Line',
    usefulLife: 10,
    residualValue: 60,
    serialNumber: 'MEET-6-009',
    manufacturer: 'Office Furniture Co',
    model: 'Meeting Pro',
    barcode: 'BC-FURN-009',
    supplierId: 'SUP-010',
    supplierName: 'Office Furniture Co',
    purchaseOrderNumber: 'PO-2023-022',
    imageUrl: 'https://images.unsplash.com/photo-1556761175-4b46a572b786?w=400&h=300&fit=crop',
    createdBy: 'admin',
    createdDate: '2023-03-15T10:00:00Z',
    tags: ['Furniture', 'Meeting'],
  },
  {
    id: '25',
    assetId: 'FURN-010',
    name: 'Locker Unit - 10 Compartments',
    description: 'Employee locker unit',
    category: 'Furniture & Fixtures',
    subCategory: 'Storage',
    location: 'Manchester Office',
    department: 'General',
    status: 'active',
    acquisitionCost: 550.00,
    netBookValue: 440.00,
    accumulatedDepreciation: 110.00,
    currency: 'GBP',
    acquisitionDate: '2023-04-01',
    depreciationMethod: 'Straight Line',
    usefulLife: 10,
    residualValue: 50,
    serialNumber: 'LOCK-10-010',
    manufacturer: 'Steel Storage Ltd',
    model: 'Secure Lock',
    barcode: 'BC-FURN-010',
    supplierId: 'SUP-012',
    supplierName: 'Storage Solutions',
    purchaseOrderNumber: 'PO-2023-028',
    imageUrl: 'https://images.unsplash.com/photo-1600494603989-9650cf6ddd3d?w=400&h=300&fit=crop',
    createdBy: 'admin',
    createdDate: '2023-04-01T10:00:00Z',
    tags: ['Furniture', 'Storage'],
  },

  // Vehicles (10 assets)
  {
    id: '26',
    assetId: 'VEH-001',
    name: 'Ford Transit Van',
    description: 'Delivery van',
    category: 'Vehicles',
    subCategory: 'Vans',
    location: 'Birmingham Warehouse',
    department: 'Logistics',
    status: 'active',
    acquisitionCost: 28000.00,
    netBookValue: 16800.00,
    accumulatedDepreciation: 11200.00,
    currency: 'GBP',
    acquisitionDate: '2021-06-01',
    depreciationMethod: 'Reducing Balance',
    usefulLife: 8,
    residualValue: 3000,
    serialNumber: 'FT-2021-001',
    manufacturer: 'Ford',
    model: 'Transit',
    barcode: 'BC-VEH-001',
    insurancePolicyNumber: 'INS-2024-026',
    insuranceProvider: 'Commercial Vehicle Insurance',
    insuranceExpiryDate: '2025-11-25',
    insuranceValue: 28000.00,
    supplierId: 'SUP-020',
    supplierName: 'Ford Commercial',
    purchaseOrderNumber: 'PO-2021-045',
    imageUrl: 'https://images.unsplash.com/photo-1527786356703-4b100091cd2c?w=400&h=300&fit=crop',
    createdBy: 'admin',
    createdDate: '2021-06-01T10:00:00Z',
    tags: ['Vehicle', 'Delivery'],
  },
  {
    id: '27',
    assetId: 'VEH-002',
    name: 'Mercedes Sprinter',
    description: 'Large delivery van',
    category: 'Vehicles',
    subCategory: 'Vans',
    location: 'London HQ',
    department: 'Logistics',
    status: 'active',
    acquisitionCost: 35000.00,
    netBookValue: 21000.00,
    accumulatedDepreciation: 14000.00,
    currency: 'GBP',
    acquisitionDate: '2021-09-15',
    depreciationMethod: 'Reducing Balance',
    usefulLife: 8,
    residualValue: 4000,
    serialNumber: 'MS-2021-002',
    manufacturer: 'Mercedes',
    model: 'Sprinter',
    barcode: 'BC-VEH-002',
    supplierId: 'SUP-021',
    supplierName: 'Mercedes Commercial',
    purchaseOrderNumber: 'PO-2021-078',
    imageUrl: 'https://images.unsplash.com/photo-1619767886558-efdc259cde1a?w=400&h=300&fit=crop',
    createdBy: 'admin',
    createdDate: '2021-09-15T10:00:00Z',
    tags: ['Vehicle', 'Delivery'],
  },
  {
    id: '28',
    assetId: 'VEH-003',
    name: 'BMW 5 Series',
    description: 'Executive car',
    category: 'Vehicles',
    subCategory: 'Cars',
    location: 'London HQ',
    department: 'Management',
    status: 'active',
    acquisitionCost: 42000.00,
    netBookValue: 25200.00,
    accumulatedDepreciation: 16800.00,
    currency: 'GBP',
    acquisitionDate: '2022-01-10',
    depreciationMethod: 'Reducing Balance',
    usefulLife: 6,
    residualValue: 8000,
    serialNumber: 'BMW5-2022-003',
    manufacturer: 'BMW',
    model: '5 Series',
    barcode: 'BC-VEH-003',
    supplierId: 'SUP-022',
    supplierName: 'BMW Dealership',
    purchaseOrderNumber: 'PO-2022-003',
    imageUrl: 'https://images.unsplash.com/photo-1555215695-3004980ad54e?w=400&h=300&fit=crop',
    createdBy: 'admin',
    createdDate: '2022-01-10T10:00:00Z',
    tags: ['Vehicle', 'Executive'],
  },
  {
    id: '29',
    assetId: 'VEH-004',
    name: 'Audi A6',
    description: 'Executive car',
    category: 'Vehicles',
    subCategory: 'Cars',
    location: 'Manchester Office',
    department: 'Sales',
    status: 'active',
    acquisitionCost: 38000.00,
    netBookValue: 22800.00,
    accumulatedDepreciation: 15200.00,
    currency: 'GBP',
    acquisitionDate: '2022-03-15',
    depreciationMethod: 'Reducing Balance',
    usefulLife: 6,
    residualValue: 7000,
    serialNumber: 'AUDIA6-2022-004',
    manufacturer: 'Audi',
    model: 'A6',
    barcode: 'BC-VEH-004',
    supplierId: 'SUP-023',
    supplierName: 'Audi Dealership',
    purchaseOrderNumber: 'PO-2022-022',
    imageUrl: 'https://images.unsplash.com/photo-1606664515524-ed2f786a0bd6?w=400&h=300&fit=crop',
    createdBy: 'admin',
    createdDate: '2022-03-15T10:00:00Z',
    tags: ['Vehicle', 'Executive'],
  },
  {
    id: '30',
    assetId: 'VEH-005',
    name: 'Volkswagen Caddy',
    description: 'Small van',
    category: 'Vehicles',
    subCategory: 'Vans',
    location: 'Edinburgh Branch',
    department: 'Maintenance',
    status: 'active',
    acquisitionCost: 22000.00,
    netBookValue: 13200.00,
    accumulatedDepreciation: 8800.00,
    currency: 'GBP',
    acquisitionDate: '2022-06-01',
    depreciationMethod: 'Reducing Balance',
    usefulLife: 7,
    residualValue: 2500,
    serialNumber: 'VWC-2022-005',
    manufacturer: 'Volkswagen',
    model: 'Caddy',
    barcode: 'BC-VEH-005',
    supplierId: 'SUP-024',
    supplierName: 'VW Commercial',
    purchaseOrderNumber: 'PO-2022-048',
    imageUrl: 'https://images.unsplash.com/photo-1527786356703-4b100091cd2c?w=400&h=300&fit=crop',
    createdBy: 'admin',
    createdDate: '2022-06-01T10:00:00Z',
    tags: ['Vehicle', 'Maintenance'],
  },
  {
    id: '31',
    assetId: 'VEH-006',
    name: 'Toyota Hilux',
    description: 'Pickup truck',
    category: 'Vehicles',
    subCategory: 'Trucks',
    location: 'Birmingham Warehouse',
    department: 'Operations',
    status: 'active',
    acquisitionCost: 32000.00,
    netBookValue: 19200.00,
    accumulatedDepreciation: 12800.00,
    currency: 'GBP',
    acquisitionDate: '2022-09-01',
    depreciationMethod: 'Reducing Balance',
    usefulLife: 8,
    residualValue: 4000,
    serialNumber: 'TH-2022-006',
    manufacturer: 'Toyota',
    model: 'Hilux',
    barcode: 'BC-VEH-006',
    supplierId: 'SUP-025',
    supplierName: 'Toyota Commercial',
    purchaseOrderNumber: 'PO-2022-075',
    imageUrl: 'https://images.unsplash.com/photo-1533473359331-0135ef1b58bf?w=400&h=300&fit=crop',
    createdBy: 'admin',
    createdDate: '2022-09-01T10:00:00Z',
    tags: ['Vehicle', 'Operations'],
  },
  {
    id: '32',
    assetId: 'VEH-007',
    name: 'Nissan Leaf',
    description: 'Electric car',
    category: 'Vehicles',
    subCategory: 'Cars',
    location: 'London HQ',
    department: 'General',
    status: 'active',
    acquisitionCost: 28000.00,
    netBookValue: 16800.00,
    accumulatedDepreciation: 11200.00,
    currency: 'GBP',
    acquisitionDate: '2023-01-15',
    depreciationMethod: 'Reducing Balance',
    usefulLife: 6,
    residualValue: 5000,
    serialNumber: 'NL-2023-007',
    manufacturer: 'Nissan',
    model: 'Leaf',
    barcode: 'BC-VEH-007',
    supplierId: 'SUP-026',
    supplierName: 'Nissan Dealership',
    purchaseOrderNumber: 'PO-2023-008',
    imageUrl: 'https://images.unsplash.com/photo-1593941707882-a5bba14938c7?w=400&h=300&fit=crop',
    createdBy: 'admin',
    createdDate: '2023-01-15T10:00:00Z',
    tags: ['Vehicle', 'Electric'],
  },
  {
    id: '33',
    assetId: 'VEH-008',
    name: 'Ford Ranger',
    description: 'Pickup truck',
    category: 'Vehicles',
    subCategory: 'Trucks',
    location: 'Manchester Office',
    department: 'Operations',
    status: 'active',
    acquisitionCost: 30000.00,
    netBookValue: 18000.00,
    accumulatedDepreciation: 12000.00,
    currency: 'GBP',
    acquisitionDate: '2023-03-01',
    depreciationMethod: 'Reducing Balance',
    usefulLife: 8,
    residualValue: 3500,
    serialNumber: 'FR-2023-008',
    manufacturer: 'Ford',
    model: 'Ranger',
    barcode: 'BC-VEH-008',
    supplierId: 'SUP-020',
    supplierName: 'Ford Commercial',
    purchaseOrderNumber: 'PO-2023-020',
    imageUrl: 'https://images.unsplash.com/photo-1533473359331-0135ef1b58bf?w=400&h=300&fit=crop',
    createdBy: 'admin',
    createdDate: '2023-03-01T10:00:00Z',
    tags: ['Vehicle', 'Operations'],
  },
  {
    id: '34',
    assetId: 'VEH-009',
    name: 'Vauxhall Vivaro',
    description: 'Medium van',
    category: 'Vehicles',
    subCategory: 'Vans',
    location: 'Birmingham Warehouse',
    department: 'Logistics',
    status: 'active',
    acquisitionCost: 26000.00,
    netBookValue: 15600.00,
    accumulatedDepreciation: 10400.00,
    currency: 'GBP',
    acquisitionDate: '2023-06-01',
    depreciationMethod: 'Reducing Balance',
    usefulLife: 7,
    residualValue: 3000,
    serialNumber: 'VV-2023-009',
    manufacturer: 'Vauxhall',
    model: 'Vivaro',
    barcode: 'BC-VEH-009',
    supplierId: 'SUP-027',
    supplierName: 'Vauxhall Commercial',
    purchaseOrderNumber: 'PO-2023-052',
    imageUrl: 'https://images.unsplash.com/photo-1527786356703-4b100091cd2c?w=400&h=300&fit=crop',
    createdBy: 'admin',
    createdDate: '2023-06-01T10:00:00Z',
    tags: ['Vehicle', 'Delivery'],
  },
  {
    id: '35',
    assetId: 'VEH-010',
    name: 'Tesla Model 3',
    description: 'Electric executive car',
    category: 'Vehicles',
    subCategory: 'Cars',
    location: 'London HQ',
    department: 'Management',
    status: 'active',
    acquisitionCost: 45000.00,
    netBookValue: 27000.00,
    accumulatedDepreciation: 18000.00,
    currency: 'GBP',
    acquisitionDate: '2023-09-01',
    depreciationMethod: 'Reducing Balance',
    usefulLife: 6,
    residualValue: 10000,
    serialNumber: 'TM3-2023-010',
    manufacturer: 'Tesla',
    model: 'Model 3',
    barcode: 'BC-VEH-010',
    supplierId: 'SUP-028',
    supplierName: 'Tesla Dealership',
    purchaseOrderNumber: 'PO-2023-082',
    imageUrl: 'https://images.unsplash.com/photo-1560958089-b8a1929cea89?w=400&h=300&fit=crop',
    createdBy: 'admin',
    createdDate: '2023-09-01T10:00:00Z',
    tags: ['Vehicle', 'Electric', 'Executive'],
  },

  // Machinery (10 assets)
  {
    id: '36',
    assetId: 'MACH-001',
    name: 'Toyota Forklift 3-Ton',
    description: 'Electric forklift',
    category: 'Machinery',
    subCategory: 'Material Handling',
    location: 'Birmingham Warehouse',
    department: 'Warehouse',
    status: 'active',
    acquisitionCost: 25000.00,
    netBookValue: 18750.00,
    accumulatedDepreciation: 6250.00,
    currency: 'GBP',
    acquisitionDate: '2021-03-01',
    depreciationMethod: 'Straight Line',
    usefulLife: 12,
    residualValue: 2500,
    serialNumber: 'TF3T-2021-001',
    manufacturer: 'Toyota',
    model: 'Forklift 3T',
    barcode: 'BC-MACH-001',
    supplierId: 'SUP-030',
    supplierName: 'Industrial Equipment Ltd',
    purchaseOrderNumber: 'PO-2021-025',
    imageUrl: 'https://images.unsplash.com/photo-1586528116311-ad8dd3c8310d?w=400&h=300&fit=crop',
    createdBy: 'admin',
    createdDate: '2021-03-01T10:00:00Z',
    tags: ['Machinery', 'Warehouse'],
  },
  {
    id: '37',
    assetId: 'MACH-002',
    name: 'CNC Milling Machine',
    description: 'Precision milling machine',
    category: 'Machinery',
    subCategory: 'Manufacturing',
    location: 'Birmingham Warehouse',
    department: 'Production',
    status: 'active',
    acquisitionCost: 85000.00,
    netBookValue: 63750.00,
    accumulatedDepreciation: 21250.00,
    currency: 'GBP',
    acquisitionDate: '2021-06-15',
    depreciationMethod: 'Straight Line',
    usefulLife: 15,
    residualValue: 8000,
    serialNumber: 'CNC-2021-002',
    manufacturer: 'Haas Automation',
    model: 'VF-2',
    barcode: 'BC-MACH-002',
    supplierId: 'SUP-031',
    supplierName: 'Machine Tools UK',
    purchaseOrderNumber: 'PO-2021-052',
    imageUrl: 'https://images.unsplash.com/photo-1565193566173-7a0ee3dbe261?w=400&h=300&fit=crop',
    createdBy: 'admin',
    createdDate: '2021-06-15T10:00:00Z',
    tags: ['Machinery', 'Manufacturing'],
  },
  {
    id: '38',
    assetId: 'MACH-003',
    name: 'Industrial Air Compressor',
    description: 'High-capacity air compressor',
    category: 'Machinery',
    subCategory: 'Support Equipment',
    location: 'Birmingham Warehouse',
    department: 'Maintenance',
    status: 'active',
    acquisitionCost: 12000.00,
    netBookValue: 9000.00,
    accumulatedDepreciation: 3000.00,
    currency: 'GBP',
    acquisitionDate: '2021-09-01',
    depreciationMethod: 'Straight Line',
    usefulLife: 12,
    residualValue: 1000,
    serialNumber: 'IAC-2021-003',
    manufacturer: 'Atlas Copco',
    model: 'GA 30',
    barcode: 'BC-MACH-003',
    supplierId: 'SUP-032',
    supplierName: 'Compressor Solutions',
    purchaseOrderNumber: 'PO-2021-078',
    imageUrl: 'https://images.unsplash.com/photo-1581092918056-0c4c3acd3789?w=400&h=300&fit=crop',
    createdBy: 'admin',
    createdDate: '2021-09-01T10:00:00Z',
    tags: ['Machinery', 'Support'],
  },
  {
    id: '39',
    assetId: 'MACH-004',
    name: 'Pallet Wrapper Machine',
    description: 'Automatic pallet wrapping',
    category: 'Machinery',
    subCategory: 'Packaging',
    location: 'Birmingham Warehouse',
    department: 'Logistics',
    status: 'active',
    acquisitionCost: 8500.00,
    netBookValue: 6375.00,
    accumulatedDepreciation: 2125.00,
    currency: 'GBP',
    acquisitionDate: '2022-01-15',
    depreciationMethod: 'Straight Line',
    usefulLife: 10,
    residualValue: 850,
    serialNumber: 'PW-2022-004',
    manufacturer: 'Robopac',
    model: 'Robot S6',
    barcode: 'BC-MACH-004',
    supplierId: 'SUP-033',
    supplierName: 'Packaging Equipment Ltd',
    purchaseOrderNumber: 'PO-2022-008',
    imageUrl: 'https://images.unsplash.com/photo-1586528116311-ad8dd3c8310d?w=400&h=300&fit=crop',
    createdBy: 'admin',
    createdDate: '2022-01-15T10:00:00Z',
    tags: ['Machinery', 'Packaging'],
  },
  {
    id: '40',
    assetId: 'MACH-005',
    name: 'Laser Cutting Machine',
    description: 'Fiber laser cutter',
    category: 'Machinery',
    subCategory: 'Manufacturing',
    location: 'Birmingham Warehouse',
    department: 'Production',
    status: 'active',
    acquisitionCost: 120000.00,
    netBookValue: 90000.00,
    accumulatedDepreciation: 30000.00,
    currency: 'GBP',
    acquisitionDate: '2022-03-01',
    depreciationMethod: 'Straight Line',
    usefulLife: 15,
    residualValue: 12000,
    serialNumber: 'LC-2022-005',
    manufacturer: 'Trumpf',
    model: 'TruLaser 3030',
    barcode: 'BC-MACH-005',
    supplierId: 'SUP-031',
    supplierName: 'Machine Tools UK',
    purchaseOrderNumber: 'PO-2022-018',
    imageUrl: 'https://images.unsplash.com/photo-1565193566173-7a0ee3dbe261?w=400&h=300&fit=crop',
    createdBy: 'admin',
    createdDate: '2022-03-01T10:00:00Z',
    tags: ['Machinery', 'Manufacturing'],
  },
  {
    id: '41',
    assetId: 'MACH-006',
    name: 'Industrial Printer - Large Format',
    description: 'Wide format printer',
    category: 'Machinery',
    subCategory: 'Printing',
    location: 'London HQ',
    department: 'Marketing',
    status: 'active',
    acquisitionCost: 35000.00,
    netBookValue: 26250.00,
    accumulatedDepreciation: 8750.00,
    currency: 'GBP',
    acquisitionDate: '2022-06-01',
    depreciationMethod: 'Straight Line',
    usefulLife: 10,
    residualValue: 3500,
    serialNumber: 'IP-LF-2022-006',
    manufacturer: 'HP',
    model: 'Latex 700',
    barcode: 'BC-MACH-006',
    supplierId: 'SUP-034',
    supplierName: 'Print Solutions UK',
    purchaseOrderNumber: 'PO-2022-045',
    imageUrl: 'https://images.unsplash.com/photo-1612815154858-60aa4c59eaa6?w=400&h=300&fit=crop',
    createdBy: 'admin',
    createdDate: '2022-06-01T10:00:00Z',
    tags: ['Machinery', 'Printing'],
  },
  {
    id: '42',
    assetId: 'MACH-007',
    name: 'Hydraulic Press - 50 Ton',
    description: 'Industrial hydraulic press',
    category: 'Machinery',
    subCategory: 'Manufacturing',
    location: 'Birmingham Warehouse',
    department: 'Production',
    status: 'active',
    acquisitionCost: 45000.00,
    netBookValue: 33750.00,
    accumulatedDepreciation: 11250.00,
    currency: 'GBP',
    acquisitionDate: '2022-09-01',
    depreciationMethod: 'Straight Line',
    usefulLife: 15,
    residualValue: 4500,
    serialNumber: 'HP-50T-2022-007',
    manufacturer: 'Enerpac',
    model: 'P50',
    barcode: 'BC-MACH-007',
    supplierId: 'SUP-035',
    supplierName: 'Hydraulic Systems Ltd',
    purchaseOrderNumber: 'PO-2022-078',
    imageUrl: 'https://images.unsplash.com/photo-1581092918056-0c4c3acd3789?w=400&h=300&fit=crop',
    createdBy: 'admin',
    createdDate: '2022-09-01T10:00:00Z',
    tags: ['Machinery', 'Manufacturing'],
  },
  {
    id: '43',
    assetId: 'MACH-008',
    name: 'Conveyor Belt System - 50m',
    description: 'Automated conveyor system',
    category: 'Machinery',
    subCategory: 'Material Handling',
    location: 'Birmingham Warehouse',
    department: 'Warehouse',
    status: 'active',
    acquisitionCost: 28000.00,
    netBookValue: 21000.00,
    accumulatedDepreciation: 7000.00,
    currency: 'GBP',
    acquisitionDate: '2023-01-10',
    depreciationMethod: 'Straight Line',
    usefulLife: 12,
    residualValue: 2800,
    serialNumber: 'CB-50M-2023-008',
    manufacturer: 'Conveyor Systems Ltd',
    model: 'CS-50',
    barcode: 'BC-MACH-008',
    supplierId: 'SUP-036',
    supplierName: 'Automation Solutions',
    purchaseOrderNumber: 'PO-2023-005',
    imageUrl: 'https://images.unsplash.com/photo-1586528116311-ad8dd3c8310d?w=400&h=300&fit=crop',
    createdBy: 'admin',
    createdDate: '2023-01-10T10:00:00Z',
    tags: ['Machinery', 'Automation'],
  },
  {
    id: '44',
    assetId: 'MACH-009',
    name: 'Welding Robot',
    description: 'Automated welding system',
    category: 'Machinery',
    subCategory: 'Manufacturing',
    location: 'Birmingham Warehouse',
    department: 'Production',
    status: 'active',
    acquisitionCost: 95000.00,
    netBookValue: 71250.00,
    accumulatedDepreciation: 23750.00,
    currency: 'GBP',
    acquisitionDate: '2023-03-01',
    depreciationMethod: 'Straight Line',
    usefulLife: 15,
    residualValue: 9500,
    serialNumber: 'WR-2023-009',
    manufacturer: 'ABB Robotics',
    model: 'IRB 1600',
    barcode: 'BC-MACH-009',
    supplierId: 'SUP-037',
    supplierName: 'Robotics UK',
    purchaseOrderNumber: 'PO-2023-022',
    imageUrl: 'https://images.unsplash.com/photo-1565193566173-7a0ee3dbe261?w=400&h=300&fit=crop',
    createdBy: 'admin',
    createdDate: '2023-03-01T10:00:00Z',
    tags: ['Machinery', 'Robotics'],
  },
  {
    id: '45',
    assetId: 'MACH-010',
    name: 'Packaging Line Equipment',
    description: 'Complete packaging line',
    category: 'Machinery',
    subCategory: 'Packaging',
    location: 'Birmingham Warehouse',
    department: 'Logistics',
    status: 'active',
    acquisitionCost: 180000.00,
    netBookValue: 135000.00,
    accumulatedDepreciation: 45000.00,
    currency: 'GBP',
    acquisitionDate: '2023-06-01',
    depreciationMethod: 'Straight Line',
    usefulLife: 15,
    residualValue: 18000,
    serialNumber: 'PLE-2023-010',
    manufacturer: 'Bosch Packaging',
    model: 'SVE 2520',
    barcode: 'BC-MACH-010',
    supplierId: 'SUP-033',
    supplierName: 'Packaging Equipment Ltd',
    purchaseOrderNumber: 'PO-2023-055',
    imageUrl: 'https://images.unsplash.com/photo-1581092918056-0c4c3acd3789?w=400&h=300&fit=crop',
    createdBy: 'admin',
    createdDate: '2023-06-01T10:00:00Z',
    tags: ['Machinery', 'Packaging'],
  },

  // Buildings (5 assets)
  {
    id: '46',
    assetId: 'BLDG-001',
    name: 'London Head Office Building',
    description: '5-storey office building',
    category: 'Buildings',
    subCategory: 'Office',
    location: 'London HQ',
    department: 'General',
    status: 'active',
    acquisitionCost: 2500000.00,
    netBookValue: 2250000.00,
    accumulatedDepreciation: 250000.00,
    currency: 'GBP',
    acquisitionDate: '2020-01-15',
    depreciationMethod: 'Straight Line',
    usefulLife: 50,
    residualValue: 500000,
    serialNumber: 'BLDG-LON-001',
    manufacturer: 'N/A',
    model: 'N/A',
    barcode: 'BC-BLDG-001',
    supplierId: 'SUP-040',
    supplierName: 'Property Developers Ltd',
    purchaseOrderNumber: 'PO-2020-001',
    imageUrl: 'https://images.unsplash.com/photo-1486406146926-c627a92ad1ab?w=400&h=300&fit=crop',
    createdBy: 'admin',
    createdDate: '2020-01-15T10:00:00Z',
    tags: ['Building', 'Office'],
  },
  {
    id: '47',
    assetId: 'BLDG-002',
    name: 'Birmingham Warehouse Facility',
    description: 'Large warehouse and distribution center',
    category: 'Buildings',
    subCategory: 'Warehouse',
    location: 'Birmingham Warehouse',
    department: 'Logistics',
    status: 'active',
    acquisitionCost: 1800000.00,
    netBookValue: 1620000.00,
    accumulatedDepreciation: 180000.00,
    currency: 'GBP',
    acquisitionDate: '2020-06-01',
    depreciationMethod: 'Straight Line',
    usefulLife: 50,
    residualValue: 360000,
    serialNumber: 'BLDG-BIR-002',
    manufacturer: 'N/A',
    model: 'N/A',
    barcode: 'BC-BLDG-002',
    supplierId: 'SUP-040',
    supplierName: 'Property Developers Ltd',
    purchaseOrderNumber: 'PO-2020-025',
    imageUrl: 'https://images.unsplash.com/photo-1553413077-190dd305871c?w=400&h=300&fit=crop',
    createdBy: 'admin',
    createdDate: '2020-06-01T10:00:00Z',
    tags: ['Building', 'Warehouse'],
  },
  {
    id: '48',
    assetId: 'BLDG-003',
    name: 'Manchester Office Building',
    description: '3-storey office building',
    category: 'Buildings',
    subCategory: 'Office',
    location: 'Manchester Office',
    department: 'General',
    status: 'active',
    acquisitionCost: 1200000.00,
    netBookValue: 1080000.00,
    accumulatedDepreciation: 120000.00,
    currency: 'GBP',
    acquisitionDate: '2021-01-10',
    depreciationMethod: 'Straight Line',
    usefulLife: 50,
    residualValue: 240000,
    serialNumber: 'BLDG-MAN-003',
    manufacturer: 'N/A',
    model: 'N/A',
    barcode: 'BC-BLDG-003',
    supplierId: 'SUP-041',
    supplierName: 'Commercial Property Group',
    purchaseOrderNumber: 'PO-2021-005',
    imageUrl: 'https://images.unsplash.com/photo-1486406146926-c627a92ad1ab?w=400&h=300&fit=crop',
    createdBy: 'admin',
    createdDate: '2021-01-10T10:00:00Z',
    tags: ['Building', 'Office'],
  },
  {
    id: '49',
    assetId: 'BLDG-004',
    name: 'Edinburgh Branch Office',
    description: '2-storey office building',
    category: 'Buildings',
    subCategory: 'Office',
    location: 'Edinburgh Branch',
    department: 'General',
    status: 'active',
    acquisitionCost: 850000.00,
    netBookValue: 765000.00,
    accumulatedDepreciation: 85000.00,
    currency: 'GBP',
    acquisitionDate: '2021-06-01',
    depreciationMethod: 'Straight Line',
    usefulLife: 50,
    residualValue: 170000,
    serialNumber: 'BLDG-EDI-004',
    manufacturer: 'N/A',
    model: 'N/A',
    barcode: 'BC-BLDG-004',
    supplierId: 'SUP-042',
    supplierName: 'Scottish Property Ltd',
    purchaseOrderNumber: 'PO-2021-045',
    imageUrl: 'https://images.unsplash.com/photo-1486406146926-c627a92ad1ab?w=400&h=300&fit=crop',
    createdBy: 'admin',
    createdDate: '2021-06-01T10:00:00Z',
    tags: ['Building', 'Office'],
  },
  {
    id: '50',
    assetId: 'BLDG-005',
    name: 'Storage Facility - Birmingham',
    description: 'Small storage warehouse',
    category: 'Buildings',
    subCategory: 'Warehouse',
    location: 'Birmingham Warehouse',
    department: 'Operations',
    status: 'active',
    acquisitionCost: 650000.00,
    netBookValue: 585000.00,
    accumulatedDepreciation: 65000.00,
    currency: 'GBP',
    acquisitionDate: '2022-01-15',
    depreciationMethod: 'Straight Line',
    usefulLife: 50,
    residualValue: 130000,
    serialNumber: 'BLDG-BIR-005',
    manufacturer: 'N/A',
    model: 'N/A',
    barcode: 'BC-BLDG-005',
    supplierId: 'SUP-040',
    supplierName: 'Property Developers Ltd',
    purchaseOrderNumber: 'PO-2022-005',
    imageUrl: 'https://images.unsplash.com/photo-1553413077-190dd305871c?w=400&h=300&fit=crop',
    createdBy: 'admin',
    createdDate: '2022-01-15T10:00:00Z',
    tags: ['Building', 'Storage'],
  },

  // INACTIVE STATUS ASSETS (5 assets across all categories)
  {
    id: '51',
    assetId: 'COMP-016',
    name: 'Dell Latitude 5420 Laptop',
    description: 'Laptop - currently not in use',
    category: 'Computer Equipment',
    subCategory: 'Laptops',
    location: 'London HQ',
    department: 'Finance',
    status: 'inactive',
    acquisitionCost: 1100.00,
    netBookValue: 275.00,
    accumulatedDepreciation: 825.00,
    currency: 'GBP',
    acquisitionDate: '2020-06-15',
    depreciationMethod: 'Straight Line',
    usefulLife: 4,
    residualValue: 100,
    serialNumber: 'DL5420-016',
    manufacturer: 'Dell',
    model: 'Latitude 5420',
    barcode: 'BC-COMP-016',
    supplierId: 'SUP-001',
    supplierName: 'Tech Solutions UK',
    purchaseOrderNumber: 'PO-2020-089',
    notes: 'Stored in IT storage room - awaiting reassignment',
    imageUrl: 'https://images.unsplash.com/photo-1588872657578-7efd1f1555ed?w=400&h=300&fit=crop',
    createdBy: 'admin',
    createdDate: '2020-06-15T10:00:00Z',
    tags: ['IT', 'Finance', 'Inactive'],
  },
  {
    id: '52',
    assetId: 'FURN-011',
    name: 'Conference Table - Walnut',
    description: 'Large conference table - not currently in use',
    category: 'Furniture & Fixtures',
    subCategory: 'Tables',
    location: 'Manchester Office',
    department: 'Management',
    status: 'inactive',
    acquisitionCost: 2500.00,
    netBookValue: 1750.00,
    accumulatedDepreciation: 750.00,
    currency: 'GBP',
    acquisitionDate: '2021-03-20',
    depreciationMethod: 'Straight Line',
    usefulLife: 10,
    residualValue: 250,
    serialNumber: 'CONF-WAL-011',
    manufacturer: 'Office Furniture Co',
    model: 'Conference Walnut',
    barcode: 'BC-FURN-011',
    supplierId: 'SUP-010',
    supplierName: 'Office Furniture Co',
    purchaseOrderNumber: 'PO-2021-045',
    notes: 'Stored after office reconfiguration',
    imageUrl: 'https://images.unsplash.com/photo-1497366216548-37526070297c?w=400&h=300&fit=crop',
    createdBy: 'admin',
    createdDate: '2021-03-20T10:00:00Z',
    tags: ['Furniture', 'Management', 'Inactive'],
  },
  {
    id: '53',
    assetId: 'VEH-011',
    name: 'Ford Transit Van',
    description: 'Delivery van - off road',
    category: 'Vehicles',
    subCategory: 'Vans',
    location: 'Birmingham Warehouse',
    department: 'Operations',
    status: 'inactive',
    acquisitionCost: 28000.00,
    netBookValue: 11200.00,
    accumulatedDepreciation: 16800.00,
    currency: 'GBP',
    acquisitionDate: '2020-09-10',
    depreciationMethod: 'Straight Line',
    usefulLife: 5,
    residualValue: 3000,
    serialNumber: 'FT-VAN-011',
    manufacturer: 'Ford',
    model: 'Transit',
    barcode: 'BC-VEH-011',
    registrationNumber: 'BX20 VAN',
    supplierId: 'SUP-020',
    supplierName: 'Fleet Solutions Ltd',
    purchaseOrderNumber: 'PO-2020-156',
    notes: 'Awaiting decision on disposal',
    imageUrl: 'https://images.unsplash.com/photo-1562911791-c7a97b729ec5?w=400&h=300&fit=crop',
    createdBy: 'admin',
    createdDate: '2020-09-10T10:00:00Z',
    tags: ['Vehicle', 'Operations', 'Inactive'],
  },
  {
    id: '54',
    assetId: 'MACH-011',
    name: 'Pallet Jack - Manual',
    description: 'Manual pallet jack - not in use',
    category: 'Machinery',
    subCategory: 'Material Handling',
    location: 'Edinburgh Branch',
    department: 'Operations',
    status: 'inactive',
    acquisitionCost: 850.00,
    netBookValue: 340.00,
    accumulatedDepreciation: 510.00,
    currency: 'GBP',
    acquisitionDate: '2020-11-15',
    depreciationMethod: 'Straight Line',
    usefulLife: 5,
    residualValue: 100,
    serialNumber: 'PJ-MAN-011',
    manufacturer: 'Yale',
    model: 'Manual Pallet Jack',
    barcode: 'BC-MACH-011',
    supplierId: 'SUP-030',
    supplierName: 'Industrial Equipment Ltd',
    purchaseOrderNumber: 'PO-2020-198',
    notes: 'Replaced by electric model',
    imageUrl: 'https://images.unsplash.com/photo-1586528116311-ad8dd3c8310d?w=400&h=300&fit=crop',
    createdBy: 'admin',
    createdDate: '2020-11-15T10:00:00Z',
    tags: ['Machinery', 'Operations', 'Inactive'],
  },
  {
    id: '55',
    assetId: 'COMP-017',
    name: 'HP ProBook 450',
    description: 'Business laptop - not in use',
    category: 'Computer Equipment',
    subCategory: 'Laptops',
    location: 'London HQ',
    department: 'Sales',
    status: 'inactive',
    acquisitionCost: 950.00,
    netBookValue: 237.50,
    accumulatedDepreciation: 712.50,
    currency: 'GBP',
    acquisitionDate: '2020-08-20',
    depreciationMethod: 'Straight Line',
    usefulLife: 4,
    residualValue: 100,
    serialNumber: 'HP450-017',
    manufacturer: 'HP',
    model: 'ProBook 450',
    barcode: 'BC-COMP-017',
    supplierId: 'SUP-001',
    supplierName: 'Tech Solutions UK',
    purchaseOrderNumber: 'PO-2020-134',
    notes: 'In storage - employee left company',
    imageUrl: 'https://images.unsplash.com/photo-1496181133206-80ce9b88a853?w=400&h=300&fit=crop',
    createdBy: 'admin',
    createdDate: '2020-08-20T10:00:00Z',
    tags: ['IT', 'Sales', 'Inactive'],
  },

  // MAINTENANCE STATUS ASSETS (5 assets across all categories)
  {
    id: '56',
    assetId: 'COMP-018',
    name: 'Lenovo ThinkPad T14',
    description: 'Laptop - undergoing repairs',
    category: 'Computer Equipment',
    subCategory: 'Laptops',
    location: 'Manchester Office',
    department: 'IT',
    status: 'maintenance',
    acquisitionCost: 1350.00,
    netBookValue: 1012.50,
    accumulatedDepreciation: 337.50,
    currency: 'GBP',
    acquisitionDate: '2023-05-10',
    depreciationMethod: 'Straight Line',
    usefulLife: 4,
    residualValue: 150,
    serialNumber: 'LTT14-018',
    manufacturer: 'Lenovo',
    model: 'ThinkPad T14',
    barcode: 'BC-COMP-018',
    supplierId: 'SUP-002',
    supplierName: 'Computer World',
    purchaseOrderNumber: 'PO-2023-056',
    notes: 'Screen replacement in progress',
    imageUrl: 'https://images.unsplash.com/photo-1588872657578-7efd1f1555ed?w=400&h=300&fit=crop',
    createdBy: 'admin',
    createdDate: '2023-05-10T10:00:00Z',
    tags: ['IT', 'Maintenance'],
  },
  {
    id: '57',
    assetId: 'FURN-012',
    name: 'Ergonomic Office Chair',
    description: 'Office chair - being repaired',
    category: 'Furniture & Fixtures',
    subCategory: 'Seating',
    location: 'London HQ',
    department: 'Finance',
    status: 'maintenance',
    acquisitionCost: 450.00,
    netBookValue: 315.00,
    accumulatedDepreciation: 135.00,
    currency: 'GBP',
    acquisitionDate: '2022-06-15',
    depreciationMethod: 'Straight Line',
    usefulLife: 7,
    residualValue: 50,
    serialNumber: 'ERGO-CH-012',
    manufacturer: 'Herman Miller',
    model: 'Aeron',
    barcode: 'BC-FURN-012',
    supplierId: 'SUP-010',
    supplierName: 'Office Furniture Co',
    purchaseOrderNumber: 'PO-2022-078',
    notes: 'Hydraulic cylinder replacement',
    imageUrl: 'https://images.unsplash.com/photo-1580480055273-228ff5388ef8?w=400&h=300&fit=crop',
    createdBy: 'admin',
    createdDate: '2022-06-15T10:00:00Z',
    tags: ['Furniture', 'Finance', 'Maintenance'],
  },
  {
    id: '58',
    assetId: 'VEH-012',
    name: 'Mercedes Sprinter Van',
    description: 'Delivery van - in workshop',
    category: 'Vehicles',
    subCategory: 'Vans',
    location: 'Birmingham Warehouse',
    department: 'Operations',
    status: 'maintenance',
    acquisitionCost: 35000.00,
    netBookValue: 24500.00,
    accumulatedDepreciation: 10500.00,
    currency: 'GBP',
    acquisitionDate: '2022-04-20',
    depreciationMethod: 'Straight Line',
    usefulLife: 5,
    residualValue: 5000,
    serialNumber: 'MS-SPR-012',
    manufacturer: 'Mercedes-Benz',
    model: 'Sprinter',
    barcode: 'BC-VEH-012',
    registrationNumber: 'BX22 SPR',
    supplierId: 'SUP-020',
    supplierName: 'Fleet Solutions Ltd',
    purchaseOrderNumber: 'PO-2022-089',
    notes: 'Engine service and brake replacement',
    imageUrl: 'https://images.unsplash.com/photo-1562911791-c7a97b729ec5?w=400&h=300&fit=crop',
    createdBy: 'admin',
    createdDate: '2022-04-20T10:00:00Z',
    tags: ['Vehicle', 'Operations', 'Maintenance'],
  },
  {
    id: '59',
    assetId: 'MACH-012',
    name: 'CNC Milling Machine',
    description: 'Manufacturing equipment - scheduled maintenance',
    category: 'Machinery',
    subCategory: 'Manufacturing',
    location: 'Birmingham Warehouse',
    department: 'Production',
    status: 'maintenance',
    acquisitionCost: 85000.00,
    netBookValue: 63750.00,
    accumulatedDepreciation: 21250.00,
    currency: 'GBP',
    acquisitionDate: '2022-08-01',
    depreciationMethod: 'Straight Line',
    usefulLife: 10,
    residualValue: 8500,
    serialNumber: 'CNC-MILL-012',
    manufacturer: 'Haas',
    model: 'VF-2',
    barcode: 'BC-MACH-012',
    supplierId: 'SUP-030',
    supplierName: 'Industrial Equipment Ltd',
    purchaseOrderNumber: 'PO-2022-145',
    notes: 'Annual preventive maintenance',
    imageUrl: 'https://images.unsplash.com/photo-1565193566173-7a0ee3dbe261?w=400&h=300&fit=crop',
    createdBy: 'admin',
    createdDate: '2022-08-01T10:00:00Z',
    tags: ['Machinery', 'Production', 'Maintenance'],
  },
  {
    id: '60',
    assetId: 'COMP-019',
    name: 'Dell OptiPlex 9020',
    description: 'Desktop computer - hardware upgrade',
    category: 'Computer Equipment',
    subCategory: 'Desktops',
    location: 'Edinburgh Branch',
    department: 'Customer Service',
    status: 'maintenance',
    acquisitionCost: 850.00,
    netBookValue: 212.50,
    accumulatedDepreciation: 637.50,
    currency: 'GBP',
    acquisitionDate: '2020-10-15',
    depreciationMethod: 'Straight Line',
    usefulLife: 4,
    residualValue: 100,
    serialNumber: 'DO9020-019',
    manufacturer: 'Dell',
    model: 'OptiPlex 9020',
    barcode: 'BC-COMP-019',
    supplierId: 'SUP-001',
    supplierName: 'Tech Solutions UK',
    purchaseOrderNumber: 'PO-2020-178',
    notes: 'RAM and SSD upgrade in progress',
    imageUrl: 'https://images.unsplash.com/photo-1587831990711-23ca6441447b?w=400&h=300&fit=crop',
    createdBy: 'admin',
    createdDate: '2020-10-15T10:00:00Z',
    tags: ['IT', 'Customer Service', 'Maintenance'],
  },

  // DISPOSED STATUS ASSETS (5 assets across all categories)
  {
    id: '61',
    assetId: 'COMP-020',
    name: 'HP EliteBook 820',
    description: 'Laptop - disposed/recycled',
    category: 'Computer Equipment',
    subCategory: 'Laptops',
    location: 'London HQ',
    department: 'Finance',
    status: 'disposed',
    acquisitionCost: 1200.00,
    netBookValue: 0.00,
    accumulatedDepreciation: 1200.00,
    currency: 'GBP',
    acquisitionDate: '2018-03-15',
    depreciationMethod: 'Straight Line',
    usefulLife: 4,
    residualValue: 100,
    serialNumber: 'HP820-020',
    manufacturer: 'HP',
    model: 'EliteBook 820',
    barcode: 'BC-COMP-020',
    supplierId: 'SUP-001',
    supplierName: 'Tech Solutions UK',
    purchaseOrderNumber: 'PO-2018-045',
    notes: 'Disposed via certified IT recycling company - 2024-01-15',
    imageUrl: 'https://images.unsplash.com/photo-1496181133206-80ce9b88a853?w=400&h=300&fit=crop',
    createdBy: 'admin',
    createdDate: '2018-03-15T10:00:00Z',
    tags: ['IT', 'Finance', 'Disposed'],
  },
  {
    id: '62',
    assetId: 'FURN-013',
    name: 'Old Filing Cabinet',
    description: 'Metal filing cabinet - disposed',
    category: 'Furniture & Fixtures',
    subCategory: 'Storage',
    location: 'Manchester Office',
    department: 'Administration',
    status: 'disposed',
    acquisitionCost: 350.00,
    netBookValue: 0.00,
    accumulatedDepreciation: 350.00,
    currency: 'GBP',
    acquisitionDate: '2015-06-10',
    depreciationMethod: 'Straight Line',
    usefulLife: 10,
    residualValue: 30,
    serialNumber: 'FILE-CAB-013',
    manufacturer: 'Office Furniture Co',
    model: 'Standard Filing',
    barcode: 'BC-FURN-013',
    supplierId: 'SUP-010',
    supplierName: 'Office Furniture Co',
    purchaseOrderNumber: 'PO-2015-023',
    notes: 'Disposed during office renovation - 2023-12-20',
    imageUrl: 'https://images.unsplash.com/photo-1524758631624-e2822e304c36?w=400&h=300&fit=crop',
    createdBy: 'admin',
    createdDate: '2015-06-10T10:00:00Z',
    tags: ['Furniture', 'Administration', 'Disposed'],
  },
  {
    id: '63',
    assetId: 'VEH-013',
    name: 'Vauxhall Vivaro Van',
    description: 'Delivery van - sold',
    category: 'Vehicles',
    subCategory: 'Vans',
    location: 'Birmingham Warehouse',
    department: 'Operations',
    status: 'disposed',
    acquisitionCost: 22000.00,
    netBookValue: 0.00,
    accumulatedDepreciation: 22000.00,
    currency: 'GBP',
    acquisitionDate: '2017-05-20',
    depreciationMethod: 'Straight Line',
    usefulLife: 5,
    residualValue: 2500,
    serialNumber: 'VV-VAN-013',
    manufacturer: 'Vauxhall',
    model: 'Vivaro',
    barcode: 'BC-VEH-013',
    registrationNumber: 'BX17 VIV',
    supplierId: 'SUP-020',
    supplierName: 'Fleet Solutions Ltd',
    purchaseOrderNumber: 'PO-2017-089',
    notes: 'Sold to third party - 2023-11-30',
    imageUrl: 'https://images.unsplash.com/photo-1562911791-c7a97b729ec5?w=400&h=300&fit=crop',
    createdBy: 'admin',
    createdDate: '2017-05-20T10:00:00Z',
    tags: ['Vehicle', 'Operations', 'Disposed'],
  },
  {
    id: '64',
    assetId: 'MACH-013',
    name: 'Old Forklift - Electric',
    description: 'Material handling equipment - disposed',
    category: 'Machinery',
    subCategory: 'Material Handling',
    location: 'Birmingham Warehouse',
    department: 'Operations',
    status: 'disposed',
    acquisitionCost: 18000.00,
    netBookValue: 0.00,
    accumulatedDepreciation: 18000.00,
    currency: 'GBP',
    acquisitionDate: '2016-08-15',
    depreciationMethod: 'Straight Line',
    usefulLife: 7,
    residualValue: 2000,
    serialNumber: 'FL-ELEC-013',
    manufacturer: 'Toyota',
    model: 'Electric Forklift',
    barcode: 'BC-MACH-013',
    supplierId: 'SUP-030',
    supplierName: 'Industrial Equipment Ltd',
    purchaseOrderNumber: 'PO-2016-134',
    notes: 'Traded in for new model - 2023-10-15',
    imageUrl: 'https://images.unsplash.com/photo-1586528116311-ad8dd3c8310d?w=400&h=300&fit=crop',
    createdBy: 'admin',
    createdDate: '2016-08-15T10:00:00Z',
    tags: ['Machinery', 'Operations', 'Disposed'],
  },
  {
    id: '65',
    assetId: 'COMP-021',
    name: 'Acer Desktop PC',
    description: 'Desktop computer - recycled',
    category: 'Computer Equipment',
    subCategory: 'Desktops',
    location: 'Edinburgh Branch',
    department: 'HR',
    status: 'disposed',
    acquisitionCost: 650.00,
    netBookValue: 0.00,
    accumulatedDepreciation: 650.00,
    currency: 'GBP',
    acquisitionDate: '2017-11-20',
    depreciationMethod: 'Straight Line',
    usefulLife: 5,
    residualValue: 50,
    serialNumber: 'ACER-PC-021',
    manufacturer: 'Acer',
    model: 'Aspire TC',
    barcode: 'BC-COMP-021',
    supplierId: 'SUP-002',
    supplierName: 'Computer World',
    purchaseOrderNumber: 'PO-2017-198',
    notes: 'Recycled through IT disposal service - 2024-02-01',
    imageUrl: 'https://images.unsplash.com/photo-1587831990711-23ca6441447b?w=400&h=300&fit=crop',
    createdBy: 'admin',
    createdDate: '2017-11-20T10:00:00Z',
    tags: ['IT', 'HR', 'Disposed'],
  },

  // PENDING STATUS ASSETS (5 assets across all categories)
  {
    id: '66',
    assetId: 'COMP-022',
    name: 'Dell XPS 13 Laptop',
    description: 'New laptop - pending setup',
    category: 'Computer Equipment',
    subCategory: 'Laptops',
    location: 'London HQ',
    department: 'IT',
    status: 'pending',
    acquisitionCost: 1650.00,
    netBookValue: 1650.00,
    accumulatedDepreciation: 0.00,
    currency: 'GBP',
    acquisitionDate: '2024-03-01',
    depreciationMethod: 'Straight Line',
    usefulLife: 4,
    residualValue: 200,
    serialNumber: 'DXPS13-022',
    manufacturer: 'Dell',
    model: 'XPS 13',
    barcode: 'BC-COMP-022',
    supplierId: 'SUP-001',
    supplierName: 'Tech Solutions UK',
    purchaseOrderNumber: 'PO-2024-015',
    notes: 'Awaiting software installation and user assignment',
    imageUrl: 'https://images.unsplash.com/photo-1593642632559-0c6d3fc62b89?w=400&h=300&fit=crop',
    createdBy: 'admin',
    createdDate: '2024-03-01T10:00:00Z',
    tags: ['IT', 'Pending'],
  },
  {
    id: '67',
    assetId: 'FURN-014',
    name: 'Standing Desk - Electric',
    description: 'Height-adjustable desk - pending installation',
    category: 'Furniture & Fixtures',
    subCategory: 'Desks',
    location: 'Manchester Office',
    department: 'Development',
    status: 'pending',
    acquisitionCost: 850.00,
    netBookValue: 850.00,
    accumulatedDepreciation: 0.00,
    currency: 'GBP',
    acquisitionDate: '2024-03-05',
    depreciationMethod: 'Straight Line',
    usefulLife: 10,
    residualValue: 100,
    serialNumber: 'STAND-DSK-014',
    manufacturer: 'Flexispot',
    model: 'E7 Pro',
    barcode: 'BC-FURN-014',
    supplierId: 'SUP-010',
    supplierName: 'Office Furniture Co',
    purchaseOrderNumber: 'PO-2024-018',
    notes: 'Delivered - awaiting assembly and placement',
    imageUrl: 'https://images.unsplash.com/photo-1518455027359-f3f8164ba6bd?w=400&h=300&fit=crop',
    createdBy: 'admin',
    createdDate: '2024-03-05T10:00:00Z',
    tags: ['Furniture', 'Development', 'Pending'],
  },
  {
    id: '68',
    assetId: 'VEH-014',
    name: 'Nissan e-NV200 Electric Van',
    description: 'Electric delivery van - pending registration',
    category: 'Vehicles',
    subCategory: 'Vans',
    location: 'Birmingham Warehouse',
    department: 'Operations',
    status: 'pending',
    acquisitionCost: 32000.00,
    netBookValue: 32000.00,
    accumulatedDepreciation: 0.00,
    currency: 'GBP',
    acquisitionDate: '2024-03-10',
    depreciationMethod: 'Straight Line',
    usefulLife: 5,
    residualValue: 4000,
    serialNumber: 'NIS-ENV-014',
    manufacturer: 'Nissan',
    model: 'e-NV200',
    barcode: 'BC-VEH-014',
    supplierId: 'SUP-020',
    supplierName: 'Fleet Solutions Ltd',
    purchaseOrderNumber: 'PO-2024-022',
    notes: 'Awaiting vehicle registration and insurance setup',
    imageUrl: 'https://images.unsplash.com/photo-1562911791-c7a97b729ec5?w=400&h=300&fit=crop',
    createdBy: 'admin',
    createdDate: '2024-03-10T10:00:00Z',
    tags: ['Vehicle', 'Operations', 'Pending', 'Electric'],
  },
  {
    id: '69',
    assetId: 'MACH-014',
    name: 'Automated Packaging System',
    description: 'Packaging machinery - pending installation',
    category: 'Machinery',
    subCategory: 'Packaging',
    location: 'Birmingham Warehouse',
    department: 'Production',
    status: 'pending',
    acquisitionCost: 45000.00,
    netBookValue: 45000.00,
    accumulatedDepreciation: 0.00,
    currency: 'GBP',
    acquisitionDate: '2024-03-12',
    depreciationMethod: 'Straight Line',
    usefulLife: 10,
    residualValue: 5000,
    serialNumber: 'AUTO-PKG-014',
    manufacturer: 'Packaging Systems Inc',
    model: 'AutoPack 3000',
    barcode: 'BC-MACH-014',
    supplierId: 'SUP-030',
    supplierName: 'Industrial Equipment Ltd',
    purchaseOrderNumber: 'PO-2024-025',
    notes: 'Delivered - awaiting installation and commissioning',
    imageUrl: 'https://images.unsplash.com/photo-1586528116311-ad8dd3c8310d?w=400&h=300&fit=crop',
    createdBy: 'admin',
    createdDate: '2024-03-12T10:00:00Z',
    tags: ['Machinery', 'Production', 'Pending'],
  },
  {
    id: '70',
    assetId: 'COMP-023',
    name: 'Microsoft Surface Studio',
    description: 'All-in-one desktop - pending deployment',
    category: 'Computer Equipment',
    subCategory: 'Desktops',
    location: 'London HQ',
    department: 'Design',
    status: 'pending',
    acquisitionCost: 3500.00,
    netBookValue: 3500.00,
    accumulatedDepreciation: 0.00,
    currency: 'GBP',
    acquisitionDate: '2024-03-15',
    depreciationMethod: 'Straight Line',
    usefulLife: 5,
    residualValue: 500,
    serialNumber: 'MS-STUD-023',
    manufacturer: 'Microsoft',
    model: 'Surface Studio 2+',
    barcode: 'BC-COMP-023',
    supplierId: 'SUP-004',
    supplierName: 'Microsoft Store',
    purchaseOrderNumber: 'PO-2024-028',
    notes: 'Awaiting design software installation',
    imageUrl: 'https://images.unsplash.com/photo-1517694712202-14dd9538aa97?w=400&h=300&fit=crop',
    createdBy: 'admin',
    createdDate: '2024-03-15T10:00:00Z',
    tags: ['IT', 'Design', 'Pending'],
  },
];

// Helper function to generate dates relative to today
const generateDateDaysAgo = (daysAgo: number): string => {
  const date = new Date();
  date.setDate(date.getDate() - daysAgo);
  return date.toISOString().split('T')[0];
};


const formatPostedDate = (daysAgo: number): string => {
  const date = new Date();
  date.setDate(date.getDate() - daysAgo);
  const day = String(date.getDate()).padStart(2, '0');
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const year = date.getFullYear();
  return `${day}/${month}/${year}`;
};

// Old mock transactions (kept for reference, but not exported)
const _oldMockTransactions: Transaction[] = [
  // Last 7 days (3 transactions)
  {
    id: '1',
    assetId: '1',
    assetName: 'Dell Latitude 7420 Laptop',
    type: 'addition',
    transactionDate: generateDateDaysAgo(2),
    amount: 1250.00,
    currency: 'GBP',
    status: 'posted',
    description: 'New laptop purchase for Finance department',
    preparedBy: 'John Smith',
    preparedDate: new Date(Date.now() - 2 * 24 * 60 * 60 * 1000).toISOString(),
    postedBy: 'Sarah Johnson',
    postedDate: new Date(Date.now() - 2 * 24 * 60 * 60 * 1000).toISOString(),
    journalReference: 'ADD-2024-0156',
  },
  {
    id: '2',
    assetId: '2',
    assetName: 'HP EliteBook 840',
    type: 'depreciation',
    transactionDate: generateDateDaysAgo(4),
    amount: 22.92,
    currency: 'GBP',
    status: 'posted',
    description: 'Monthly depreciation adjustment',
    preparedBy: 'System',
    preparedDate: new Date(Date.now() - 4 * 24 * 60 * 60 * 1000).toISOString(),
    postedBy: 'Betty Davis',
    postedDate: new Date(Date.now() - 4 * 24 * 60 * 60 * 1000).toISOString(),
    journalReference: 'DEP-2024-001',
  },
  {
    id: '3',
    assetId: '3',
    assetName: 'Lenovo ThinkPad X1',
    type: 'revaluation',
    transactionDate: generateDateDaysAgo(6),
    amount: 1500.00,
    currency: 'GBP',
    status: 'approved',
    description: 'Market value adjustment after appraisal',
    preparedBy: 'Mike Myers',
    preparedDate: new Date(Date.now() - 6 * 24 * 60 * 60 * 1000).toISOString(),
    postedBy: 'Sarah Johnson',
    postedDate: new Date(Date.now() - 6 * 24 * 60 * 60 * 1000).toISOString(),
    journalReference: 'REV-2024-001',
  },
  
  // Last 8-14 days (2 additional transactions = 5 total in last 14 days)
  {
    id: '4',
    assetId: '16',
    assetName: 'Executive Desk - Oak',
    type: 'addition',
    transactionDate: generateDateDaysAgo(9),
    amount: 1200.00,
    currency: 'GBP',
    status: 'posted',
    description: 'Large executive desk for Management',
    preparedBy: 'David Lee',
    preparedDate: new Date(Date.now() - 9 * 24 * 60 * 60 * 1000).toISOString(),
    postedBy: 'Betty Davis',
    postedDate: new Date(Date.now() - 9 * 24 * 60 * 60 * 1000).toISOString(),
    journalReference: 'ADD-2024-0215',
  },
  {
    id: '5',
    assetId: '17',
    assetName: 'Herman Miller Aeron Chair',
    type: 'addition',
    transactionDate: generateDateDaysAgo(12),
    amount: 950.00,
    currency: 'GBP',
    status: 'posted',
    description: 'Ergonomic office chair for executive',
    preparedBy: 'Emma Wilson',
    preparedDate: new Date(Date.now() - 12 * 24 * 60 * 60 * 1000).toISOString(),
    postedBy: 'Mike Myers',
    postedDate: new Date(Date.now() - 12 * 24 * 60 * 60 * 1000).toISOString(),
    journalReference: 'ADD-2024-0220',
  },
  
  // Last 15-30 days (16 additional transactions = 21 total in last 30 days)
  {
    id: '6',
    assetId: '7',
    assetName: 'MacBook Pro 16"',
    type: 'addition',
    transactionDate: generateDateDaysAgo(15),
    amount: 3200.00,
    currency: 'GBP',
    status: 'approved',
    description: 'High-performance laptop for Development',
    preparedBy: 'Emma Wilson',
    preparedDate: new Date(Date.now() - 15 * 24 * 60 * 60 * 1000).toISOString(),
    postedBy: 'Sarah Johnson',
    postedDate: new Date(Date.now() - 15 * 24 * 60 * 60 * 1000).toISOString(),
    journalReference: 'ADD-2024-0189',
  },
  {
    id: '7',
    assetId: '26',
    assetName: 'Ford Transit Van',
    type: 'revaluation',
    transactionDate: generateDateDaysAgo(17),
    amount: 28000.00,
    currency: 'GBP',
    status: 'rejected',
    description: 'Revaluation rejected - insufficient documentation',
    preparedBy: 'James Wilson',
    preparedDate: new Date(Date.now() - 17 * 24 * 60 * 60 * 1000).toISOString(),
    journalReference: 'REV-2024-0245',
  },
  {
    id: '8',
    assetId: '8',
    assetName: 'Dell XPS 15',
    type: 'depreciation',
    transactionDate: generateDateDaysAgo(18),
    amount: 208.33,
    currency: 'GBP',
    status: 'posted',
    description: 'Monthly depreciation',
    preparedBy: 'System',
    preparedDate: new Date(Date.now() - 18 * 24 * 60 * 60 * 1000).toISOString(),
    postedBy: 'Betty Davis',
    postedDate: new Date(Date.now() - 18 * 24 * 60 * 60 * 1000).toISOString(),
    journalReference: 'DEP-2024-002',
  },
  {
    id: '9',
    assetId: '19',
    assetName: 'Standing Desk - Electric',
    type: 'addition',
    transactionDate: generateDateDaysAgo(19),
    amount: 850.00,
    currency: 'GBP',
    status: 'posted',
    description: 'Ergonomic standing desk for office',
    preparedBy: 'Emma Wilson',
    preparedDate: new Date(Date.now() - 19 * 24 * 60 * 60 * 1000).toISOString(),
    postedBy: 'Mike Myers',
    postedDate: new Date(Date.now() - 19 * 24 * 60 * 60 * 1000).toISOString(),
    journalReference: 'ADD-2024-0189',
  },
  {
    id: '10',
    assetId: '20',
    assetName: 'Office Chair - Mesh Back',
    type: 'addition',
    transactionDate: generateDateDaysAgo(20),
    amount: 450.00,
    currency: 'GBP',
    status: 'pending',
    description: 'Office chair for marketing department',
    preparedBy: 'Lisa Anderson',
    preparedDate: new Date(Date.now() - 20 * 24 * 60 * 60 * 1000).toISOString(),
    journalReference: 'ADD-2024-0201',
  },
  {
    id: '11',
    assetId: '27',
    assetName: 'Mercedes Sprinter',
    type: 'revaluation',
    transactionDate: generateDateDaysAgo(21),
    amount: 35000.00,
    currency: 'GBP',
    status: 'approved',
    description: 'Annual market value assessment',
    preparedBy: 'Robert Taylor',
    preparedDate: new Date(Date.now() - 21 * 24 * 60 * 60 * 1000).toISOString(),
    postedBy: 'Sarah Johnson',
    postedDate: new Date(Date.now() - 21 * 24 * 60 * 60 * 1000).toISOString(),
    journalReference: 'REV-2024-002',
  },
  {
    id: '12',
    assetId: '4',
    assetName: 'Apple iMac 27"',
    type: 'depreciation',
    transactionDate: generateDateDaysAgo(22),
    amount: 125.00,
    currency: 'GBP',
    status: 'posted',
    description: 'Monthly depreciation',
    preparedBy: 'System',
    preparedDate: new Date(Date.now() - 22 * 24 * 60 * 60 * 1000).toISOString(),
    postedBy: 'Betty Davis',
    postedDate: new Date(Date.now() - 22 * 24 * 60 * 60 * 1000).toISOString(),
    journalReference: 'DEP-2024-003',
  },
  {
    id: '13',
    assetId: '35',
    assetName: 'Toyota Forklift 3-Ton',
    type: 'addition',
    transactionDate: generateDateDaysAgo(23),
    amount: 12500.00,
    currency: 'GBP',
    status: 'posted',
    description: 'New forklift for warehouse operations',
    preparedBy: 'James Wilson',
    preparedDate: new Date(Date.now() - 23 * 24 * 60 * 60 * 1000).toISOString(),
    postedBy: 'Mike Myers',
    postedDate: new Date(Date.now() - 23 * 24 * 60 * 60 * 1000).toISOString(),
    journalReference: 'ADD-2024-0245',
  },
  {
    id: '14',
    assetId: '18',
    assetName: 'Filing Cabinet - 4 Drawer',
    type: 'addition',
    transactionDate: generateDateDaysAgo(24),
    amount: 320.00,
    currency: 'GBP',
    status: 'posted',
    description: 'Storage cabinet for HR department',
    preparedBy: 'David Lee',
    preparedDate: new Date(Date.now() - 24 * 24 * 60 * 60 * 1000).toISOString(),
    postedBy: 'Sarah Johnson',
    postedDate: new Date(Date.now() - 24 * 24 * 60 * 60 * 1000).toISOString(),
    journalReference: 'ADD-2024-0258',
  },
  {
    id: '15',
    assetId: '5',
    assetName: 'Dell OptiPlex 7090',
    type: 'depreciation',
    transactionDate: generateDateDaysAgo(25),
    amount: 166.67,
    currency: 'GBP',
    status: 'posted',
    description: 'Monthly depreciation',
    preparedBy: 'System',
    preparedDate: new Date(Date.now() - 25 * 24 * 60 * 60 * 1000).toISOString(),
    postedBy: 'Betty Davis',
    postedDate: new Date(Date.now() - 25 * 24 * 60 * 60 * 1000).toISOString(),
    journalReference: 'DEP-2024-004',
  },
  {
    id: '16',
    assetId: '21',
    assetName: 'Reception Desk',
    type: 'revaluation',
    transactionDate: generateDateDaysAgo(26),
    amount: 1800.00,
    currency: 'GBP',
    status: 'approved',
    description: 'Market value adjustment after refurbishment',
    preparedBy: 'Michael Brown',
    preparedDate: new Date(Date.now() - 26 * 24 * 60 * 60 * 1000).toISOString(),
    postedBy: 'Mike Myers',
    postedDate: new Date(Date.now() - 26 * 24 * 60 * 60 * 1000).toISOString(),
    journalReference: 'REV-2024-003',
  },
  {
    id: '17',
    assetId: '6',
    assetName: 'HP ProDesk 600',
    type: 'addition',
    transactionDate: generateDateDaysAgo(27),
    amount: 899.00,
    currency: 'GBP',
    status: 'posted',
    description: 'Desktop computer for accounting',
    preparedBy: 'Lisa Anderson',
    preparedDate: new Date(Date.now() - 27 * 24 * 60 * 60 * 1000).toISOString(),
    postedBy: 'Sarah Johnson',
    postedDate: new Date(Date.now() - 27 * 24 * 60 * 60 * 1000).toISOString(),
    journalReference: 'ADD-2024-0289',
  },
  {
    id: '18',
    assetId: '9',
    assetName: 'HP ZBook Studio',
    type: 'depreciation',
    transactionDate: generateDateDaysAgo(28),
    amount: 187.50,
    currency: 'GBP',
    status: 'posted',
    description: 'Monthly depreciation',
    preparedBy: 'System',
    preparedDate: new Date(Date.now() - 28 * 24 * 60 * 60 * 1000).toISOString(),
    postedBy: 'Betty Davis',
    postedDate: new Date(Date.now() - 28 * 24 * 60 * 60 * 1000).toISOString(),
    journalReference: 'DEP-2024-005',
  },
  {
    id: '19',
    assetId: '38',
    assetName: 'Industrial Printer - Large Format',
    type: 'addition',
    transactionDate: generateDateDaysAgo(29),
    amount: 4500.00,
    currency: 'GBP',
    status: 'pending',
    description: 'Large format printer for design department',
    preparedBy: 'David Lee',
    preparedDate: new Date(Date.now() - 29 * 24 * 60 * 60 * 1000).toISOString(),
    journalReference: 'ADD-2024-0301',
  },
  {
    id: '20',
    assetId: '10',
    assetName: 'Lenovo ThinkCentre M90',
    type: 'revaluation',
    transactionDate: generateDateDaysAgo(29),
    amount: 750.00,
    currency: 'GBP',
    status: 'rejected',
    description: 'Revaluation rejected - asset condition below standard',
    preparedBy: 'Emma Wilson',
    preparedDate: new Date(Date.now() - 29 * 24 * 60 * 60 * 1000).toISOString(),
    journalReference: 'REV-2024-004',
  },
  {
    id: '21',
    assetId: '11',
    assetName: 'Dell Precision 5560',
    type: 'depreciation',
    transactionDate: generateDateDaysAgo(30),
    amount: 145.83,
    currency: 'GBP',
    status: 'posted',
    description: 'Monthly depreciation',
    preparedBy: 'System',
    preparedDate: new Date(Date.now() - 30 * 24 * 60 * 60 * 1000).toISOString(),
    postedBy: 'Betty Davis',
    postedDate: new Date(Date.now() - 30 * 24 * 60 * 60 * 1000).toISOString(),
    journalReference: 'DEP-2024-006',
  },
];

// Calculate Total Asset Value dynamically from mockAssets
const calculateTotalAssetValue = (): number => {
  return mockAssets.reduce((total, asset) => total + asset.netBookValue, 0);
};

export const mockKPIs: KPI[] = [
  {
    label: 'Total Asset Value',
    value: calculateTotalAssetValue(),
    change: 5.2,
    trend: 'up',
    icon: 'Package',
  },
  {
    label: 'Active Assets',
    value: 1234,
    change: 2.1,
    trend: 'up',
    icon: 'TrendingUp',
  },
  {
    label: 'Depreciation (YTD)',
    value: 125000,
    change: -3.5,
    trend: 'down',
    icon: 'ArrowDownCircle',
  },
  {
    label: 'Assets Due for Review',
    value: 23,
    change: -12.5,
    trend: 'down',
    icon: 'AlertCircle',
  },
];

// Assets Due for Review Breakdown
export const assetsDueForReviewBreakdown = {
  totalCount: 23,
  depreciationCount: 12,
  insuranceCount: 6,
  warrantyCount: 5,
};

export const mockAuditLog: AuditEntry[] = [
  // Recent activity (last 7 days)
  {
    id: '1',
    assetId: '1',
    action: 'Asset Created',
    user: 'John Smith',
    timestamp: generateDateDaysAgo(1),
    field: 'status',
    oldValue: '',
    newValue: 'active',
    notes: 'New Dell Latitude 7420 Laptop added to inventory',
  },
  {
    id: '2',
    assetId: '2',
    action: 'Asset Updated',
    user: 'Sarah Johnson',
    timestamp: generateDateDaysAgo(1),
    field: 'location',
    oldValue: 'London HQ',
    newValue: 'Manchester Office',
    notes: 'HP EliteBook 840 relocated for new team member',
  },
  {
    id: '3',
    assetId: '3',
    action: 'Depreciation Applied',
    user: 'System',
    timestamp: generateDateDaysAgo(2),
    field: 'netBookValue',
    oldValue: '1200.00',
    newValue: '1125.00',
    notes: 'Monthly depreciation batch DEP-2024-001',
  },
  {
    id: '4',
    assetId: '4',
    action: 'Asset Updated',
    user: 'Mike Davis',
    timestamp: generateDateDaysAgo(2),
    field: 'assignedTo',
    oldValue: 'Unassigned',
    newValue: 'Emma Wilson',
    notes: 'Apple iMac 27" assigned to new Marketing Manager',
  },
  {
    id: '5',
    assetId: '5',
    action: 'Revaluation Applied',
    user: 'Betty Davis',
    timestamp: generateDateDaysAgo(3),
    field: 'netBookValue',
    oldValue: '850.00',
    newValue: '920.00',
    notes: 'Market value adjustment - Dell OptiPlex 7090',
  },
  {
    id: '6',
    assetId: '6',
    action: 'Asset Created',
    user: 'John Smith',
    timestamp: generateDateDaysAgo(3),
    field: 'status',
    oldValue: '',
    newValue: 'active',
    notes: 'HP ProDesk 600 added from PO-2024-089',
  },
  {
    id: '7',
    assetId: '7',
    action: 'Status Changed',
    user: 'Sarah Johnson',
    timestamp: generateDateDaysAgo(4),
    field: 'status',
    oldValue: 'active',
    newValue: 'maintenance',
    notes: 'MacBook Pro 16" sent for repair - screen issue',
  },
  {
    id: '8',
    assetId: '8',
    action: 'Asset Updated',
    user: 'Mike Davis',
    timestamp: generateDateDaysAgo(4),
    field: 'warrantyExpiryDate',
    oldValue: '2024-12-31',
    newValue: '2025-12-31',
    notes: 'Dell XPS 15 warranty extended',
  },
  {
    id: '9',
    assetId: '9',
    action: 'Addition Posted',
    user: 'Betty Davis',
    timestamp: generateDateDaysAgo(5),
    field: 'acquisitionCost',
    oldValue: '',
    newValue: '2500.00',
    notes: 'HP ZBook Studio added via batch ADD-2025-001',
  },
  {
    id: '10',
    assetId: '10',
    action: 'Asset Updated',
    user: 'Emma Wilson',
    timestamp: generateDateDaysAgo(5),
    field: 'department',
    oldValue: 'IT',
    newValue: 'Finance',
    notes: 'Lenovo ThinkCentre M90 transferred to Finance',
  },
  // Last 8-14 days
  {
    id: '11',
    assetId: '11',
    action: 'Depreciation Applied',
    user: 'System',
    timestamp: generateDateDaysAgo(8),
    field: 'netBookValue',
    oldValue: '3200.00',
    newValue: '3066.67',
    notes: 'Monthly depreciation batch DEP-2024-002',
  },
  {
    id: '12',
    assetId: '12',
    action: 'Asset Created',
    user: 'John Smith',
    timestamp: generateDateDaysAgo(9),
    field: 'status',
    oldValue: '',
    newValue: 'active',
    notes: 'Microsoft Surface Pro 9 added to inventory',
  },
  {
    id: '13',
    assetId: '13',
    action: 'Asset Updated',
    user: 'Sarah Johnson',
    timestamp: generateDateDaysAgo(10),
    field: 'insuranceExpiryDate',
    oldValue: '2024-06-30',
    newValue: '2025-06-30',
    notes: 'Dell Precision 5560 insurance renewed',
  },
  {
    id: '14',
    assetId: '14',
    action: 'Status Changed',
    user: 'Mike Davis',
    timestamp: generateDateDaysAgo(11),
    field: 'status',
    oldValue: 'maintenance',
    newValue: 'active',
    notes: 'HP Z2 Tower returned from repair',
  },
  {
    id: '15',
    assetId: '15',
    action: 'Asset Updated',
    user: 'Betty Davis',
    timestamp: generateDateDaysAgo(12),
    field: 'serialNumber',
    oldValue: 'UNKNOWN',
    newValue: 'LTY540-015',
    notes: 'Lenovo ThinkStation P340 serial number updated',
  },
  // Last 15-30 days
  {
    id: '16',
    assetId: '16',
    action: 'Asset Created',
    user: 'John Smith',
    timestamp: generateDateDaysAgo(15),
    field: 'status',
    oldValue: '',
    newValue: 'active',
    notes: 'Executive Desk - Oak added from furniture order',
  },
  {
    id: '17',
    assetId: '17',
    action: 'Addition Posted',
    user: 'Betty Davis',
    timestamp: generateDateDaysAgo(16),
    field: 'acquisitionCost',
    oldValue: '',
    newValue: '950.00',
    notes: 'Herman Miller Aeron Chair via batch ADD-2024-003',
  },
  {
    id: '18',
    assetId: '18',
    action: 'Asset Updated',
    user: 'Sarah Johnson',
    timestamp: generateDateDaysAgo(17),
    field: 'location',
    oldValue: 'Birmingham Warehouse',
    newValue: 'London HQ',
    notes: 'Filing Cabinet - 4 Drawer relocated to main office',
  },
  {
    id: '19',
    assetId: '19',
    action: 'Depreciation Applied',
    user: 'System',
    timestamp: generateDateDaysAgo(18),
    field: 'netBookValue',
    oldValue: '850.00',
    newValue: '807.50',
    notes: 'Monthly depreciation - Standing Desk Electric',
  },
  {
    id: '20',
    assetId: '20',
    action: 'Asset Created',
    user: 'Mike Davis',
    timestamp: generateDateDaysAgo(19),
    field: 'status',
    oldValue: '',
    newValue: 'active',
    notes: 'Office Chair - Mesh Back added to inventory',
  },
  {
    id: '21',
    assetId: '21',
    action: 'Asset Updated',
    user: 'Emma Wilson',
    timestamp: generateDateDaysAgo(20),
    field: 'assignedTo',
    oldValue: 'Reception',
    newValue: 'Front Desk Team',
    notes: 'Reception Desk assignment updated',
  },
  {
    id: '22',
    assetId: '22',
    action: 'Revaluation Applied',
    user: 'Betty Davis',
    timestamp: generateDateDaysAgo(21),
    field: 'netBookValue',
    oldValue: '1800.00',
    newValue: '2100.00',
    notes: 'Conference Table - 12 Seater market value increase',
  },
  {
    id: '23',
    assetId: '23',
    action: 'Asset Created',
    user: 'John Smith',
    timestamp: generateDateDaysAgo(22),
    field: 'status',
    oldValue: '',
    newValue: 'active',
    notes: 'Whiteboard - Large added for meeting room',
  },
  {
    id: '24',
    assetId: '24',
    action: 'Status Changed',
    user: 'Sarah Johnson',
    timestamp: generateDateDaysAgo(23),
    field: 'status',
    oldValue: 'active',
    newValue: 'disposed',
    notes: 'Old Bookshelf - 5 Shelf disposed - damaged beyond repair',
  },
  {
    id: '25',
    assetId: '25',
    action: 'Disposal Posted',
    user: 'Betty Davis',
    timestamp: generateDateDaysAgo(24),
    field: 'netBookValue',
    oldValue: '150.00',
    newValue: '0.00',
    notes: 'Disposal transaction posted - Bookshelf written off',
  },
  // Last 31-60 days
  {
    id: '26',
    assetId: '26',
    action: 'Asset Created',
    user: 'John Smith',
    timestamp: generateDateDaysAgo(32),
    field: 'status',
    oldValue: '',
    newValue: 'active',
    notes: 'Ford Transit Van added to fleet',
  },
  {
    id: '27',
    assetId: '27',
    action: 'Addition Posted',
    user: 'Betty Davis',
    timestamp: generateDateDaysAgo(35),
    field: 'acquisitionCost',
    oldValue: '',
    newValue: '35000.00',
    notes: 'Mercedes Sprinter via batch ADD-2024-002',
  },
  {
    id: '28',
    assetId: '28',
    action: 'Asset Updated',
    user: 'Mike Davis',
    timestamp: generateDateDaysAgo(38),
    field: 'insurancePolicyNumber',
    oldValue: 'INS-OLD-028',
    newValue: 'INS-2024-028',
    notes: 'Volkswagen Caddy insurance policy renewed',
  },
  {
    id: '29',
    assetId: '29',
    action: 'Depreciation Applied',
    user: 'System',
    timestamp: generateDateDaysAgo(40),
    field: 'netBookValue',
    oldValue: '18500.00',
    newValue: '17833.33',
    notes: 'Monthly depreciation - Nissan NV200',
  },
  {
    id: '30',
    assetId: '30',
    action: 'Status Changed',
    user: 'Sarah Johnson',
    timestamp: generateDateDaysAgo(42),
    field: 'status',
    oldValue: 'active',
    newValue: 'maintenance',
    notes: 'Toyota Hilux sent for MOT and service',
  },
  {
    id: '31',
    assetId: '31',
    action: 'Asset Created',
    user: 'John Smith',
    timestamp: generateDateDaysAgo(45),
    field: 'status',
    oldValue: '',
    newValue: 'active',
    notes: 'CNC Milling Machine added to Birmingham Warehouse',
  },
  {
    id: '32',
    assetId: '32',
    action: 'Revaluation Applied',
    user: 'Betty Davis',
    timestamp: generateDateDaysAgo(48),
    field: 'netBookValue',
    oldValue: '45000.00',
    newValue: '52000.00',
    notes: 'Industrial Lathe market value reassessment',
  },
  {
    id: '33',
    assetId: '33',
    action: 'Asset Updated',
    user: 'Emma Wilson',
    timestamp: generateDateDaysAgo(50),
    field: 'location',
    oldValue: 'Edinburgh Branch',
    newValue: 'Birmingham Warehouse',
    notes: 'Hydraulic Press relocated for production needs',
  },
  {
    id: '34',
    assetId: '34',
    action: 'Compliance Check',
    user: 'Mike Davis',
    timestamp: generateDateDaysAgo(52),
    field: 'complianceStatus',
    oldValue: 'pending',
    newValue: 'compliant',
    notes: 'Welding Station passed PUWER inspection',
  },
  {
    id: '35',
    assetId: '35',
    action: 'Asset Created',
    user: 'John Smith',
    timestamp: generateDateDaysAgo(55),
    field: 'status',
    oldValue: '',
    newValue: 'active',
    notes: 'Toyota Forklift 3-Ton added to warehouse fleet',
  },
  // Last 61-90 days
  {
    id: '36',
    assetId: '36',
    action: 'Depreciation Applied',
    user: 'System',
    timestamp: generateDateDaysAgo(62),
    field: 'netBookValue',
    oldValue: '125000.00',
    newValue: '122916.67',
    notes: 'Monthly depreciation - Office Building Annex',
  },
  {
    id: '37',
    assetId: '37',
    action: 'Asset Updated',
    user: 'Sarah Johnson',
    timestamp: generateDateDaysAgo(65),
    field: 'insuranceValue',
    oldValue: '450000.00',
    newValue: '500000.00',
    notes: 'Warehouse Building insurance coverage increased',
  },
  {
    id: '38',
    assetId: '38',
    action: 'Addition Posted',
    user: 'Betty Davis',
    timestamp: generateDateDaysAgo(68),
    field: 'acquisitionCost',
    oldValue: '',
    newValue: '85000.00',
    notes: 'Car Park Structure via batch ADD-2024-001',
  },
  {
    id: '39',
    assetId: '1',
    action: 'Photo Added',
    user: 'Emma Wilson',
    timestamp: generateDateDaysAgo(70),
    field: 'photos',
    oldValue: '0 photos',
    newValue: '1 photo',
    notes: 'Asset photo uploaded for Dell Latitude 7420',
  },
  {
    id: '40',
    assetId: '2',
    action: 'Barcode Generated',
    user: 'Mike Davis',
    timestamp: generateDateDaysAgo(72),
    field: 'barcode',
    oldValue: '',
    newValue: 'BC-COMP-002',
    notes: 'Barcode label generated for HP EliteBook 840',
  },
  {
    id: '41',
    assetId: '3',
    action: 'QR Code Generated',
    user: 'Mike Davis',
    timestamp: generateDateDaysAgo(75),
    field: 'qrCode',
    oldValue: '',
    newValue: 'QR-COMP-003',
    notes: 'QR code label generated for Lenovo ThinkPad X1',
  },
  {
    id: '42',
    assetId: '4',
    action: 'Tag Added',
    user: 'Sarah Johnson',
    timestamp: generateDateDaysAgo(78),
    field: 'tags',
    oldValue: 'IT',
    newValue: 'IT, Marketing',
    notes: 'Additional tag added to Apple iMac 27"',
  },
  {
    id: '43',
    assetId: '5',
    action: 'Notes Updated',
    user: 'John Smith',
    timestamp: generateDateDaysAgo(80),
    field: 'notes',
    oldValue: '',
    newValue: 'Upgraded RAM to 32GB',
    notes: 'Dell OptiPlex 7090 specification notes updated',
  },
  {
    id: '44',
    assetId: '6',
    action: 'Supplier Updated',
    user: 'Betty Davis',
    timestamp: generateDateDaysAgo(82),
    field: 'supplierName',
    oldValue: 'Unknown Supplier',
    newValue: 'Tech Solutions UK',
    notes: 'HP ProDesk 600 supplier information corrected',
  },
  {
    id: '45',
    assetId: '7',
    action: 'Custom Field Updated',
    user: 'Emma Wilson',
    timestamp: generateDateDaysAgo(85),
    field: 'customField1',
    oldValue: '',
    newValue: 'Development Team',
    notes: 'MacBook Pro 16" team assignment recorded',
  },
  // Older entries (90+ days)
  {
    id: '46',
    assetId: '8',
    action: 'Asset Created',
    user: 'John Smith',
    timestamp: generateDateDaysAgo(95),
    field: 'status',
    oldValue: '',
    newValue: 'active',
    notes: 'Dell XPS 15 initial registration',
  },
  {
    id: '47',
    assetId: '9',
    action: 'Asset Created',
    user: 'John Smith',
    timestamp: generateDateDaysAgo(100),
    field: 'status',
    oldValue: '',
    newValue: 'active',
    notes: 'HP ZBook Studio initial registration',
  },
  {
    id: '48',
    assetId: '10',
    action: 'Asset Created',
    user: 'John Smith',
    timestamp: generateDateDaysAgo(105),
    field: 'status',
    oldValue: '',
    newValue: 'active',
    notes: 'Lenovo ThinkCentre M90 initial registration',
  },
  {
    id: '49',
    assetId: '11',
    action: 'Asset Created',
    user: 'Sarah Johnson',
    timestamp: generateDateDaysAgo(110),
    field: 'status',
    oldValue: '',
    newValue: 'active',
    notes: 'Dell Precision 5560 initial registration',
  },
  {
    id: '50',
    assetId: '12',
    action: 'Asset Created',
    user: 'Sarah Johnson',
    timestamp: generateDateDaysAgo(115),
    field: 'status',
    oldValue: '',
    newValue: 'active',
    notes: 'Microsoft Surface Pro 9 initial registration',
  },
];

// Export as mockAuditTrail for backward compatibility
export const mockAuditTrail: typeof mockAuditLog = mockAuditLog;

// Calculate Assets by Location dynamically from mockAssets
const calculateAssetsByLocation = () => {
  // Define colors for each location (preserve existing colors)
  const locationColors: Record<string, string> = {
    'London HQ': '#3b82f6',           // Blue
    'Manchester Office': '#10b981',   // Green
    'Birmingham Warehouse': '#f59e0b', // Amber
    'Edinburgh Branch': '#8b5cf6',    // Purple
  };

  // Initialize location totals dynamically from mockAssets
  const locationTotals: Record<string, number> = {};

  // Sum up netBookValue for each location
  mockAssets.forEach(asset => {
    if (!locationTotals[asset.location]) {
      locationTotals[asset.location] = 0;
    }
    locationTotals[asset.location] += asset.netBookValue;
  });

  // Convert to array format for the card, sorted by value descending
  return Object.entries(locationTotals)
    .map(([location, value]) => ({
      location,
      value,
      color: locationColors[location] || '#6b7280', // Default gray for unmapped locations
    }))
    .sort((a, b) => b.value - a.value); // Sort by value descending
};

// Calculate assets by category from mockAssets
const calculateAssetsByCategory = () => {
  // Define colors for each category
  const categoryColors: Record<string, string> = {
    'Computer Equipment': '#3b82f6',    // Blue
    'Furniture & Fixtures': '#10b981',  // Green
    'Vehicles': '#f59e0b',              // Amber
    'Machinery': '#8b5cf6',             // Purple
    'Buildings': '#ec4899',             // Pink
  };

  // Initialize category totals dynamically from mockAssets
  const categoryTotals: Record<string, number> = {};

  // Sum up netBookValue for each category
  mockAssets.forEach(asset => {
    if (!categoryTotals[asset.category]) {
      categoryTotals[asset.category] = 0;
    }
    categoryTotals[asset.category] += asset.netBookValue;
  });

  // Convert to array format for the bar chart, sorted by value descending
  return Object.entries(categoryTotals)
    .map(([category, value]) => ({
      category,
      value,
      color: categoryColors[category] || '#6b7280', // Default gray for unmapped categories
    }))
    .sort((a, b) => b.value - a.value); // Sort by value descending
};

export const chartData = {
  assetsByStatus: [
    { name: 'Active', value: 70, fill: '#10b981' }, // Modern emerald green
    { name: 'Pending', value: 9, fill: '#f59e0b' }, // Modern amber
    { name: 'Inactive', value: 7, fill: '#6366f1' }, // Modern indigo
    { name: 'Maintenance', value: 7, fill: '#8b5cf6' }, // Modern violet
    { name: 'Disposed', value: 7, fill: '#64748b' }, // Modern slate
  ],
  assetsByLocation: calculateAssetsByLocation(),
  assetsByCategory: calculateAssetsByCategory(),
  nbvTrend: [
    { month: 'Apr', value: 2800000 },
    { month: 'May', value: 2750000 },
    { month: 'Jun', value: 2700000 },
    { month: 'Jul', value: 2650000 },
    { month: 'Aug', value: 2600000 },
    { month: 'Sep', value: 2550000 },
    { month: 'Oct', value: 2500000 },
    { month: 'Nov', value: 2450000 },
  ],
};

export const assetUtilisationData = {
  utilisationRate: 87,
  change: 2.3,
  trend: 'up' as const,
  monthlyData: [
    { month: 'Apr', rate: 72 },
    { month: 'May', rate: 75 },
    { month: 'Jun', rate: 78 },
    { month: 'Jul', rate: 76 },
    { month: 'Aug', rate: 80 },
    { month: 'Sep', rate: 82 },
    { month: 'Oct', rate: 85 },
    { month: 'Nov', rate: 87 },
  ],
};

// Depreciation YTD data - reverse exponential curve (steep decline initially, flattening over time)
export const depreciationYTDData = {
  currentValue: 125000,
  monthlyData: [
    { month: 'Apr', value: 180000 },
    { month: 'May', value: 165000 },
    { month: 'Jun', value: 152000 },
    { month: 'Jul', value: 142000 },
    { month: 'Aug', value: 135000 },
    { month: 'Sep', value: 130000 },
    { month: 'Oct', value: 127000 },
    { month: 'Nov', value: 125000 },
  ],
};

// Per-asset depreciation data for filtering
export const assetDepreciationData: Record<string, { currentValue: number; monthlyData: { month: string; value: number }[] }> = {
  '1': { // Dell Latitude 7420 Laptop - Exponential decay from £1,500
    currentValue: 1187.50,
    monthlyData: [
      { month: 'Apr', value: 1500.00 },
      { month: 'May', value: 1450.00 },
      { month: 'Jun', value: 1395.00 },
      { month: 'Jul', value: 1335.00 },
      { month: 'Aug', value: 1280.00 },
      { month: 'Sep', value: 1235.00 },
      { month: 'Oct', value: 1210.00 },
      { month: 'Nov', value: 1187.50 },
    ],
  },
  '2': { // HP EliteBook 840 - Exponential decay from £1,280
    currentValue: 1012.00,
    monthlyData: [
      { month: 'Apr', value: 1280.00 },
      { month: 'May', value: 1235.00 },
      { month: 'Jun', value: 1185.00 },
      { month: 'Jul', value: 1130.00 },
      { month: 'Aug', value: 1085.00 },
      { month: 'Sep', value: 1050.00 },
      { month: 'Oct', value: 1030.00 },
      { month: 'Nov', value: 1012.00 },
    ],
  },
  '3': { // Lenovo ThinkPad X1 - Exponential decay from £550
    currentValue: 375.00,
    monthlyData: [
      { month: 'Apr', value: 550.00 },
      { month: 'May', value: 520.00 },
      { month: 'Jun', value: 485.00 },
      { month: 'Jul', value: 450.00 },
      { month: 'Aug', value: 420.00 },
      { month: 'Sep', value: 395.00 },
      { month: 'Oct', value: 383.00 },
      { month: 'Nov', value: 375.00 },
    ],
  },
  '4': { // Apple iMac 27" - Exponential decay from £1,150
    currentValue: 880.00,
    monthlyData: [
      { month: 'Apr', value: 1150.00 },
      { month: 'May', value: 1105.00 },
      { month: 'Jun', value: 1055.00 },
      { month: 'Jul', value: 1000.00 },
      { month: 'Aug', value: 955.00 },
      { month: 'Sep', value: 920.00 },
      { month: 'Oct', value: 898.00 },
      { month: 'Nov', value: 880.00 },
    ],
  },
  '5': { // Dell OptiPlex 7090 - Exponential decay from £520
    currentValue: 380.00,
    monthlyData: [
      { month: 'Apr', value: 520.00 },
      { month: 'May', value: 495.00 },
      { month: 'Jun', value: 465.00 },
      { month: 'Jul', value: 435.00 },
      { month: 'Aug', value: 410.00 },
      { month: 'Sep', value: 393.00 },
      { month: 'Oct', value: 385.00 },
      { month: 'Nov', value: 380.00 },
    ],
  },
  '6': { // HP ProDesk 600 - Exponential decay from £1,020
    currentValue: 782.00,
    monthlyData: [
      { month: 'Apr', value: 1020.00 },
      { month: 'May', value: 980.00 },
      { month: 'Jun', value: 935.00 },
      { month: 'Jul', value: 885.00 },
      { month: 'Aug', value: 845.00 },
      { month: 'Sep', value: 815.00 },
      { month: 'Oct', value: 797.00 },
      { month: 'Nov', value: 782.00 },
    ],
  },
  '7': { // MacBook Pro 16" - Exponential decay from £2,400
    currentValue: 1600.00,
    monthlyData: [
      { month: 'Apr', value: 2400.00 },
      { month: 'May', value: 2280.00 },
      { month: 'Jun', value: 2145.00 },
      { month: 'Jul', value: 2000.00 },
      { month: 'Aug', value: 1870.00 },
      { month: 'Sep', value: 1760.00 },
      { month: 'Oct', value: 1675.00 },
      { month: 'Nov', value: 1600.00 },
    ],
  },
  '8': { // Dell XPS 15 - Exponential decay from £1,800
    currentValue: 1350.00,
    monthlyData: [
      { month: 'Apr', value: 1800.00 },
      { month: 'May', value: 1730.00 },
      { month: 'Jun', value: 1650.00 },
      { month: 'Jul', value: 1565.00 },
      { month: 'Aug', value: 1490.00 },
      { month: 'Sep', value: 1425.00 },
      { month: 'Oct', value: 1385.00 },
      { month: 'Nov', value: 1350.00 },
    ],
  },
  '9': { // HP ZBook Studio - Exponential decay from £2,500
    currentValue: 1875.00,
    monthlyData: [
      { month: 'Apr', value: 2500.00 },
      { month: 'May', value: 2400.00 },
      { month: 'Jun', value: 2285.00 },
      { month: 'Jul', value: 2160.00 },
      { month: 'Aug', value: 2050.00 },
      { month: 'Sep', value: 1960.00 },
      { month: 'Oct', value: 1915.00 },
      { month: 'Nov', value: 1875.00 },
    ],
  },
  '10': { // Lenovo ThinkCentre M90 - Exponential decay from £720
    currentValue: 540.00,
    monthlyData: [
      { month: 'Apr', value: 720.00 },
      { month: 'May', value: 690.00 },
      { month: 'Jun', value: 655.00 },
      { month: 'Jul', value: 620.00 },
      { month: 'Aug', value: 590.00 },
      { month: 'Sep', value: 565.00 },
      { month: 'Oct', value: 551.00 },
      { month: 'Nov', value: 540.00 },
    ],
  },
};

// Net Book Value data - aggregate of all assets showing gradual decline due to depreciation
export const netBookValueData = {
  currentValue: 125000, // Total NBV of all assets
  monthlyData: [
    { month: 'Apr', value: 180000 }, // Starting total NBV
    { month: 'May', value: 172000 }, // Gradual decline
    { month: 'Jun', value: 165000 }, // Continuing decline
    { month: 'Jul', value: 155000 }, // Steady depreciation
    { month: 'Aug', value: 145000 }, // Ongoing reduction
    { month: 'Sep', value: 138000 }, // Slowing decline
    { month: 'Oct', value: 130000 }, // Approaching current
    { month: 'Nov', value: 125000 }, // Current total NBV
  ],
};

// Individual asset Net Book Value data - each asset shows declining NBV over time
export const assetNetBookValueData: Record<string, { currentValue: number; monthlyData: { month: string; value: number }[] }> = {
  // Dell Latitude 7420 - Laptop
  '1': {
    currentValue: 1187.50,
    monthlyData: [
      { month: 'Apr', value: 1500.00 },
      { month: 'May', value: 1450.00 },
      { month: 'Jun', value: 1395.00 },
      { month: 'Jul', value: 1335.00 },
      { month: 'Aug', value: 1280.00 },
      { month: 'Sep', value: 1235.00 },
      { month: 'Oct', value: 1210.00 },
      { month: 'Nov', value: 1187.50 },
    ],
  },
  // MacBook Pro 16" - High-value laptop
  '2': {
    currentValue: 1600.00,
    monthlyData: [
      { month: 'Apr', value: 2400.00 },
      { month: 'May', value: 2300.00 },
      { month: 'Jun', value: 2180.00 },
      { month: 'Jul', value: 2050.00 },
      { month: 'Aug', value: 1920.00 },
      { month: 'Sep', value: 1800.00 },
      { month: 'Oct', value: 1690.00 },
      { month: 'Nov', value: 1600.00 },
    ],
  },
  // HP EliteBook 840 - Standard laptop
  '3': {
    currentValue: 1012.00,
    monthlyData: [
      { month: 'Apr', value: 1280.00 },
      { month: 'May', value: 1240.00 },
      { month: 'Jun', value: 1195.00 },
      { month: 'Jul', value: 1145.00 },
      { month: 'Aug', value: 1100.00 },
      { month: 'Sep', value: 1065.00 },
      { month: 'Oct', value: 1035.00 },
      { month: 'Nov', value: 1012.00 },
    ],
  },
  // Dell UltraSharp 27" Monitor
  '4': {
    currentValue: 285.00,
    monthlyData: [
      { month: 'Apr', value: 350.00 },
      { month: 'May', value: 340.00 },
      { month: 'Jun', value: 328.00 },
      { month: 'Jul', value: 315.00 },
      { month: 'Aug', value: 305.00 },
      { month: 'Sep', value: 298.00 },
      { month: 'Oct', value: 290.00 },
      { month: 'Nov', value: 285.00 },
    ],
  },
  // Lenovo ThinkPad X1 Carbon
  '5': {
    currentValue: 1425.00,
    monthlyData: [
      { month: 'Apr', value: 1800.00 },
      { month: 'May', value: 1740.00 },
      { month: 'Jun', value: 1675.00 },
      { month: 'Jul', value: 1605.00 },
      { month: 'Aug', value: 1540.00 },
      { month: 'Sep', value: 1485.00 },
      { month: 'Oct', value: 1450.00 },
      { month: 'Nov', value: 1425.00 },
    ],
  },
  // Conference Table - Furniture
  '6': {
    currentValue: 1140.00,
    monthlyData: [
      { month: 'Apr', value: 1200.00 },
      { month: 'May', value: 1190.00 },
      { month: 'Jun', value: 1178.00 },
      { month: 'Jul', value: 1165.00 },
      { month: 'Aug', value: 1155.00 },
      { month: 'Sep', value: 1148.00 },
      { month: 'Oct', value: 1143.00 },
      { month: 'Nov', value: 1140.00 },
    ],
  },
  // Ford Transit Van
  '7': {
    currentValue: 18500.00,
    monthlyData: [
      { month: 'Apr', value: 22000.00 },
      { month: 'May', value: 21400.00 },
      { month: 'Jun', value: 20750.00 },
      { month: 'Jul', value: 20050.00 },
      { month: 'Aug', value: 19400.00 },
      { month: 'Sep', value: 19000.00 },
      { month: 'Oct', value: 18700.00 },
      { month: 'Nov', value: 18500.00 },
    ],
  },
  // Samsung 32" Monitor
  '8': {
    currentValue: 228.00,
    monthlyData: [
      { month: 'Apr', value: 280.00 },
      { month: 'May', value: 272.00 },
      { month: 'Jun', value: 262.00 },
      { month: 'Jul', value: 252.00 },
      { month: 'Aug', value: 244.00 },
      { month: 'Sep', value: 237.00 },
      { month: 'Oct', value: 232.00 },
      { month: 'Nov', value: 228.00 },
    ],
  },
  // Office Desk - Furniture
  '9': {
    currentValue: 285.00,
    monthlyData: [
      { month: 'Apr', value: 300.00 },
      { month: 'May', value: 297.00 },
      { month: 'Jun', value: 294.00 },
      { month: 'Jul', value: 291.00 },
      { month: 'Aug', value: 289.00 },
      { month: 'Sep', value: 287.00 },
      { month: 'Oct', value: 286.00 },
      { month: 'Nov', value: 285.00 },
    ],
  },
  // Microsoft Surface Pro 8
  '10': {
    currentValue: 760.00,
    monthlyData: [
      { month: 'Apr', value: 950.00 },
      { month: 'May', value: 920.00 },
      { month: 'Jun', value: 885.00 },
      { month: 'Jul', value: 850.00 },
      { month: 'Aug', value: 820.00 },
      { month: 'Sep', value: 795.00 },
      { month: 'Oct', value: 775.00 },
      { month: 'Nov', value: 760.00 },
    ],
  },
};

// Import and re-export transactions from separate file
export { mockTransactions, getNextAuditNumber } from './mock-transactions-updated';
